{
  "ariaLabel": {
    "viewDetails": "Afficher les détails",
    "downloadDataAssets": "Télécharger les ressources de données"
  },
  "topMenu": {
    "dihTitle": "Data Intelligence Hub",
    "DIHOrgRegistration": "Data Intelligence Hub - Enregistrement d'organisation",
    "dihSubTitle": "Extraire la valeur des données en toute sécurité",
    "logout": "Se déconnecter",
    "myAccount": "Mon compte",
    "myOrganization": "Mon organisation"
  },
  "userLogoutAlert": {
    "title": "Êtes-vous sûr de vouloir vous déconnecter?",
    "back": "Retour",
    "logout": "Se déconnecter",
    "myOrganization": "Mon organisation"
  },
  "sideMenu": {
    "dashboard": "Tableau de bord",
    "connectors": "Connecteurs",
    "myConnectors": "Mes connecteurs",
    "dataspaces": "Dataspaces",
    "discover": "Découvrir",
    "manage": "Gérer",
    "marketplace": "Marché",
    "myDataspaces": "Mes adhésions",
    "browseDataspaces": "Parcourir les données",
    "organizations": "Organisations",
    "build": "Construire",
    "ownedDataspaces": "Mes espaces de données",
    "collapse": "Barre latérale d'effondrement",
    "participate": "Participer",
    "getVerified": "Être vérifié",
    "workbench": "Table de travail",
    "dataIncoming": "Données entrantes",
    "applications": "Applications",
    "verify": "Vérifier",
    "digitalIDDashboard": "Obtenir des informations",
    "mySignatures": "Mes signatures",
    "externalConnectionManager": "Gestionnaire de connexions externes"
  },
  "dropdown": {
    "selectAll": "Sélectionner tout",
    "noOption": "Aucune option disponible",
    "noSuchOption": "Cette option n'existe pas ..."
  },
  "common": {
    "start": "Commencer",
    "finish": "Terminer",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "email": "Adresse e-mail",
    "phoneNumber": "Numéro de téléphone",
    "contactPerson": "Personne de contact",
    "welcome": "Accueillir",
    "street": "Rue",
    "city": "Ville",
    "region": "Région",
    "country": "Pays",
    "postCode": "Code postal",
    "number": "Nombre",
    "next": "Suivant",
    "prev": "Précédent",
    "alreadyAccount": "Vous avez déjà un compte?",
    "login": "Se connecter",
    "loginNow": "Se connecter maintenant",
    "register": "S'inscrire",
    "home": "Page d'accueil",
    "submit": "Envoyer",
    "attention": "Attention",
    "desc": "Description",
    "website": "Site web",
    "contact": "Contact",
    "details": "Détails",
    "plan": "Plan",
    "listView": "Vue liste",
    "gridView": "Vue grille",
    "firstPage": "À la première page",
    "previousPage": "À la page précédente",
    "nextPage": "À la page suivante",
    "lastPage": "À la dernière page",
    "download": "Télécharger",
    "delete": "Supprimer",
    "edit": "Modifier",
    "information": "Information",
    "organization": "Organisation",
    "cancel": "Annuler",
    "save": "Sauvegarder",
    "upload": "Télécharger",
    "link": "Lien",
    "view": "Voir",
    "search": "Rechercher",
    "searchTerm": "Recherche",
    "selectOption": "Choisir une option",
    "sortBy": "Trier par",
    "dataspace": "Espace de données",
    "select": "Sélectionner",
    "date": "Date",
    "title": "Titre",
    "successful": "Réussite",
    "unsuccessful": "Sans succès",
    "statuses": {
      "connected": "connecté",
      "disconnected": "déconnecté",
      "deploying": "en déploiement",
      "deployed": "déployé",
      "failed": "échoué",
      "available": "disponible",
      "success": "succès",
      "active": "actif",
      "pending": "en attente",
      "declined": "refusé",
      "invited": "invité",
      "onboarding": "en cours d'intégration",
      "withdrawn": "retiré",
      "successful": "réussi",
      "unsuccessful": "sans succès",
      "valid": "valide",
      "expired": "expiré",
      "revoked": "révoqué",
      "inprogress": "en cours",
      "rejected": "rejeté",
      "inactive": "inactif",
      "subscribed": "Abonné"
    },
    "andMore": "et {count} de plus | et {count} autres",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "links": {
      "dihWiki": "https://docs.dih.telekom.com/en/home"
    },
    "formError": "Quelque chose ne va pas.",
    "question": {
      "interested": "Intéressé?"
    },
    "moreInfo": "Si vous avez besoin de plus d'informations:",
    "goToWebsite": "Aller sur notre site Web",
    "provider": "Fournisseur",
    "required": "Requis",
    "errors": "Erreurs",
    "error": "Erreur",
    "from": "De",
    "to": "À",
    "openLinkInNewTab": "Ouvrir le lien dans un nouvel onglet",
    "formatError": "Format non valide. Veuillez vérifier votre saisie et réessayer",
    "ID": "ID"
  },
  "genericError": "Oh, quelque chose a mal tourné ! Veuillez réessayer.",
  "validation": {
    "fieldRequired": "Champ requis.",
    "fieldNumeric": "Le champ peut ne contenir que des nombres.",
    "fieldAlpha": "Le champ ne peut contenir que des lettres, _ et -.",
    "fieldAlphanumeric": "Le champ ne peut contenir que des lettres, des numéros, _ et -.",
    "fieldNumericDash": "Le champ peut ne contenir que des nombres et -.",
    "fieldHouseNumber": "Le champ {field} ne peut contenir que des chiffres, des lettres et les caractères - et /.",
    "fieldPhoneNumber": "Le champ peut ne contenir que des nombres et -. Il doit commencer par + ou 00.",
    "fieldAlphaDash": "Le champ peut ne contenir que des lettres et -.",
    "exceptHTMLTagBrackets": "Le champ ne doit pas contenir les caractères suivants: ^ <>",
    "alphaNumericExtended": "Le champ {field} ne peut contenir que des lettres, des chiffres, -, /, # et .",
    "ipOrCidrRegex": "La valeur doit être une adresse IP valide",
    "isMaxLength": "dépasse la longueur maximale de 10 caractères.",
    "emailFormat": "L'adresse e-mail a un mauvais format",
    "fileSizeError": "La taille du fichier est plus grande que {size} MB.",
    "csvFileSizeError": "Ce fichier est trop gros. Vous pouvez télécharger un fichier jusqu'à {size} Mo.",
    "csvFileExtensionError": "Seuls les fichiers avec l'extension csv sont autorisés.",
    "csvFileIsEmptyError": "Ce fichier est vide. Vous devez télécharger un fichier d'au moins {size} Ko.",
    "csvFileFormatError": "Le fichier ne correspond pas au format attendu. Veuillez utiliser le modèle fourni et réessayer.",
    "uploadFails": "Échec du téléchargement",
    "fileExtensionError": "L'extension de fichier ne convient pas",
    "fileIsMalwareInfectedError": "Ce fichier semble contenir des logiciels malveillants. Pour des raisons de sécurité, ce fichier ne peut pas être téléchargé. Veuillez vérifier à nouveau votre fichier",
    "customValidation": "Le {field} a le mauvais format.",
    "selectCountryFirst": "Veuillez d'abord sélectionner le champ du nom du pays.",
    "validationPostCodeCaseDE": "Le champ a le mauvais format. Il doit contenir 5 chiffres, par exemple, 53113",
    "validationAlphanumericCase": "Le champ peut ne contenir que des caractères alphanumériques, des tirets et des soulignements. La valeur doit commencer par un caractère alphanumérique.",
    "validationNumericDashCase": "Le champ peut ne contenir que des nombres et -.",
    "url": "Veuillez saisir une URL valide",
    "maxInvitationSize": "Vous pouvez inviter jusqu’à {size} participants à la fois",
    "errorUploadingFile": "Erreur lors du téléchargement du fichier. Veuillez réessayer.",
    "password": {
      "passwordStrength": "Fiabilité du mot de passe",
      "weak": "Faible",
      "average": "Moyenne",
      "strong": "Fort",
      "passwordValidationMoreChar": "{count} ou plus de caractères",
      "passwordUpperAndLowerChar": "Caractères supérieurs et minuscules",
      "passwordAtLeastNumber": "Au moins un nombre",
      "passwordAtLeastSpecialChar": "Au moins un personnage spécial (sauf <> & \"` [])",
      "passwordDiffFromPrev": "Diffère de vos mots de passe précédents"
    },
    "orgName": "Le champ ne peut contenir que des lettres, des numéros, _ et - &.",
    "tagLimitMessage": "Vous pouvez ajouter jusqu'à {count} cas d'utilisation."
  },
  "footer": {
    "tagLine": "Passons des performances plus élevées",
    "imprint": "Imprimer",
    "imprintShort": "Mentions lég.",
    "imprintLink": "https://dih.telekom.com/en/imprint",
    "contact": "Contact",
    "contactLink": "https://dih.telekom.com/en/contact",
    "termsAndConditions": "Termes et conditions",
    "privacy": "Politique de confidentialité",
    "privacyShort": "Politique confid.",
    "telekom": "T-Systems International GmbH. Tous droits réservés.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub - pour les clients d'entreprise uniquement",
    "brandedNote": "Propulsé par Telekom Data Intelligence Hub",
    "help": "Aide",
    "cookieSettings": "Cookies",
    "cookieSettingsShort": "Cookies",
    "life": "Life is for sharing"
  },
  "onboarding": {
    "welcome": "Bienvenue sur Data Intelligence Hub",
    "welcomeDIH": "Bienvenue sur Data Intelligence Hub",
    "thankYouEnterprise": "Merci d'avoir choisi Connect & Integrate Enterprise",
    "informationForOrganization": "Les informations de votre organisation:",
    "orgNameLabel": "Nom de l'organisation",
    "orgUnitNameLabel": "Nom de l'unité d'organisation",
    "emailAddressLabel": "Adresse e-mail",
    "countryNameLabel": "Pays",
    "bpnNumberLabel": "Numéro de partenaire commercial (BPN)",
    "contactPersonInfo": "Personne de contact",
    "fillInfoBelow": "Veuillez remplir les informations ci-dessous",
    "orgRegNameLabel": "Nom enregistré de l'organisation / unité",
    "legalNameHint": "Veuillez saisir le nom légal de votre organisation",
    "addressHeading": "Adresse du siège de l'organisation",
    "PLZCode": "Code postal",
    "verifyEmail": "Vérifier l'adresse e-mail",
    "verifyEmailMessage": "Merci d'avoir rejoint Data Intelligence Hub - votre organisation est déjà enregistrée chez nous. Veuillez vérifier votre e-mail.",
    "taxId": "numéro de TVA",
    "commerceRegisterNumber": "Numéro de registre commercial",
    "orgRepresentative": {
      "title": "Configurez le compte de votre représentant de votre organisation",
      "orgContactPerson": "Interlocuteur au sein de l'organisation",
      "whatDefinesYou": "Qu'est-ce qui vous définit le mieux?",
      "agreeText": "Je confirme que j'ai lu et que j'accepte {1} de Data Intelligence Hub",
      "confirmText": "J'approuve que mes données personnelles soient stockées et traitées conformément à <a href='#'>la Déclaration de confidentialité des données</a>"
    },
    "success": "Enregistrement de l'organisation réussie",
    "underReview": "Votre organisation est en cours de vérification.",
    "verified": "Vous avez réussi à vérifier votre organisation",
    "month": "mois | {count} mois",
    "steps": {
      "counter": {
        "step": "Étape",
        "of": "de"
      },
      "stepWizard": {
        "orgInfo": "Informations sur l'organisation",
        "selectConnection": "Sélectionnez votre connexion",
        "configureConnection": "Configure votre connexion",
        "selectPackage": "Sélectionnez votre plan",
        "checkout": "Vérifier",
        "enterpriseTitle": "Nous reviendrons vers vous sous peu",
        "enterpriseSubtitle" : "En attendant, veuillez nous donner un peu plus de détails afin que nous puissions mieux vous aider."
      },
      "actionButton": {
        "back": "Retour",
        "next": "Suivant",
        "order": "Commande avec obligation de payer",
        "checkout": "Vérifier",
        "selectMyPlan": "Sélectionnez mon plan",
        "submitRequest": "Envoyer une demande",
        "editModeDisabled": "Aucune modification n’a été apportée à la commande existante."
      },
      "orgStep": {
        "fields": {
          "orgInfoLabel": "Détails de l'organisation",
          "dataSpaceAttributes": "Attributs supplémentaires",
          "orgName": "Nom légal de l'organisation",
          "departmentName": "Nom du département",
          "crnNumber": "Numéro de registre commercial",
          "taxId": "numéro de TVA",
          "bpnNo": "Numéro de partenaire commercial (BPN)",
          "addressInfo": "Adresse de facturation",
          "countryName": "Pays",
          "plzCode": "Code postal",
          "number": "Nombre",
          "city": "Ville",
          "street": "Rue",
          "contactPersonLabel": "Personne de contact",
          "fullName": "Nom et prénom",
          "firstName": "Prénom",
          "firstNamePlaceholder": "Entrez votre prénom",
          "lastName": "Nom de famille",
          "lastNamePlaceholder": "Entrez votre nom de famille",
          "contactPerson": "Personne de contact",
          "phoneNo": "Numéro de téléphone",
          "emailAdd": "Adresse e-mail",
          "dataPrivacyCheck": "Je consens à ce que mes données personnelles soient stockées et traitées conformément à {dataprivacystatement} et aux {supplementaryDataPrivacyConditions}",
          "dataPrivacyCheckNew": "J’approuve que mes données personnelles soient stockées et traitées conformément à la {dataprivacystatement}.",
          "termsAndConditionsCheck": "Je confirme qu’en tant que représentant autorisé de la société, j’ai lu, compris et accepté les {termsandcondition}.",
          "dataprivacystatement": "Déclaration de confidentialité des données",
          "supplementaryDataPrivacyConditions": "conditions supplémentaires de confidentialité des données",
          "termsandcondition": "conditions générales",
          "agreeToEnterContract": "J'accepte de conclure un contrat avec T-Systems International GmbH en fonction de la {serviceDescription} ci-dessus",
          "serviceDescription": "description du service",
          "markettingConsentCheck": "Je consens à recevoir des e-mails, des lettres, des appels ou des SMS/MMS de marketing concernant les produits, services et événements de T-Systems International GmbH et de Telekom Deutschland GmbH. Je peux retirer ce consentement à tout moment en envoyant un e-mail à {email}."
        }
      },
      "connection": {
        "sectionHeading": "Sélectionnez votre connexion",
        "sectionSubHeading": "Veuillez sélectionner votre type de connexion pour {dsName}",
        "textNote": "Seules les options compatibles avec Catena-X peuvent être sélectionnées",
        "recommendedConfiguration": "Configuration recommandée",
        "cloudProvider": "Fournisseur de cloud",
        "cloudProviderTooltip": "Fournisseur de cloud recommandé avec cet abonnement",
        "contactSales": "Contacter le service commercial"
      },
      "packages": {
        "sectionHeading": "Sélectionnez votre plan",
        "sectionSubHeading": "Variations du plan de données",
        "basedOnYourSelection": "Sur la base de votre sélection, nous recommandons ce qui suit",
        "dataPackage": "Packages de données",
        "outgoingTraffic": "Trafic sortant",
        "storage": "Stockage",
        "selectedDataPlan": "Sélectionnez le plan de données",
        "dataPlanDetails": "Détails du plan de données",
        "dataPlanLabelForVolume": "Plans avec volume inclus",
        "dataPlanLabelFlexible": "Pay-as-you-go",
        "packageAvailable": "Ce package est disponible uniquement avec ce plan",
        "chargesApply": "Les frais s'appliquent si l'utilisation dépasse la limite de volume",
        "additionalStorage": "Stockage supplémentaire",
        "additionalTraffic": "Trafic sortant supplémentaire",
        "oneTimeSetUpCharges": "Frais de configuration uniques",
        "starterKit": "Kit de démarrage",
        "starterKitTooltip": "Configurez votre environnement en toute simplicité, y compris la configuration de l’accès technique, la création de compte, les tests de fonctionnalités et l’intégration de la base de connaissances. Pour plus d’informations, reportez-vous à la description du service fournie lors du paiement",
        "onboardingKit": "Kit d’intégration",
        "onboardingKitTooltip": "Des forfaits de consultation horaires flexibles conçus pour fournir un soutien sur mesure pour la mise en œuvre de solutions d’espace de données, fournis par notre équipe de professionnels spécialisés. Pour plus d’informations, reportez-vous à la description du service fournie lors du paiement.",
        "pleaseSelectYourDesiredContractDuration": "Veuillez sélectionner la durée de contrat souhaitée",
        "subscriptionTitle": "Nombre para mostrar de la conexión",
        "subscriptionTitleLabel": "Entrez le nom d’affichage de la connexion",
        "automatedIntegrationCapabilities": "Capacités d’intégration automatisée",
        "automatedIntegrationCapabilitiesTooltip": "Les « capacités d’intégration automatisée » vous fournissent des fonctions supplémentaires pour réaliser une intégration semi-automatique avec l’espace de données. Il s’agit notamment du mappage de données, de la conversion de données à faible code, etc.",
        "boschDtrTitle": "Vous êtes à la recherche d’un registre de jumeaux numériques performant de Bosch ?",
        "optional": "Optionnel",
        "boschDtrDescription": "Bosch propose le registre des jumeaux numériques (DTR), un répertoire numérique qui permet d’identifier et de récupérer rapidement des millions de jumeaux numériques, facilitant ainsi leur création, leur attribution, leur stockage et leur suppression. Veuillez cliquer sur la case à cocher ci-dessous et notre équipe de vente se fera un plaisir de vous aider.",
        "boschDtrLearnMore": "Pour en savoir plus",
        "boschDtrContactSaleCheck": "Je souhaite être contacté par l’équipe commerciale de T-Systems International GmbH"
      },
      "zoneSelection": {
        "zoneSelectionTitle": "Où souhaitez-vous que vos données soient placées ?",
        "zoneSelectionTooltip": "Choisissez la zone où vous souhaitez que vos données se trouvent."
      },
      "cloudProviders": {
        "cloudInfrastructure": "Quel fournisseur cloud se trouve dans la zone sélectionnée ?",
        "toolipContent": "Choisissez le fournisseur de cloud qui répond le mieux à vos besoins.",
        "cloudAvailable": "Ce package est disponible uniquement sur ce fournisseur de cloud"
      },
      "checkout": {
        "sectionHeading": "Votre package de connexion à {orgName}",
        "setupCost": "Coûts de configuration",
        "monthlyCost": "Coûts mensuels",
        "payg": "Pay-as-you-go",
        "pipSheet": "Fiche d'information sur le produit",
        "totalCost": "Coût total",
        "totalPayable": "Total à payer",
        "dataPrivacyCheck": "J'accepte de payer les frais associés aux services commandés ci-dessus",
        "termsAndConditionsCheck": "J'accepte la durée du contrat et les politiques d'annulation",
        "termsandcondition": "termes et conditions",
        "EOMAmountPolicy": "J'accepte que le montant total à payer sera calculé à la fin du mois",
        "generalAgreement": "J'accepte de conclure un contrat avec T-Systems International GmbH en fonction de la description du service ci-dessus",
        "DPAAgreement": "Je consens à l'{dataprocessingagreement} (ATD)",
        "dataprocessingagreement": "Accord de traitement des données",
        "dataPackage": "Packages de données",
        "dataPlan": "Plan de données",
        "outgoingTraffic": "Trafic sortant inclus",
        "storagePrice": "Prix ​​de stockage",
        "perGigabyteForStorage": "/ Go pour le stockage",
        "perGigabyteForOutgoingTraffic": "/ Go pour le trafic sortant",
        "outgoingTrafficPrice": "Prix ​​du trafic sortant",
        "contractDuration": "Durée de contrat",
        "contractDurationIconTooltip": "Sélectionnez la durée de votre contrat en fonction de vos besoins",
        "contractDurationTooltip": "Durée du contrat recommandée avec cet abonnement",
        "defaultContractDuration": "6 mois",
        "price": "Prix",
        "perGigabyte": "par Go",
        "monthlyCancelable": "résiliable mensuellement",
        "storage": "Rangement inclus",
        "linksText": {
          "information": "Fiche d'information",
          "service": "Description du service"
        },
        "plusCharges": "{plus} Frais de votre consommation",
        "plus": "plus",
        "basedOnConsumption": "en fonction de la consommation",
        "selectedConfiguration": "Configuration sélectionnée",
        "oneTimeCosts": "Coûts non récurrents",
        "connectionType": "Type de connexion",
        "dataIntegrationLevel": "Niveau d’intégration des données",
        "addOns": "Modules complémentaires",
        "connectors": "Connecteurs",
        "totalUseCases": "Cas d’utilisation total",
        "totalAmount": "Montant total",
        "supplementaryDataPrivacyConditionsCheck": "Je consens à ce que mes données personnelles soient stockées et traitées conformément aux {supplementaryDataPrivacyConditions}",
        "supplementaryDataPrivacyConditions": "Conditions supplémentaires de confidentialité des données",
        "withIncludedVolume": "avec volume inclus",
        "cloudProvider": "Fournisseur de cloud",
        "selectedZone": "Région",
        "additionalCharges": "*Des frais s’appliquent si vous dépassez votre volume mensuel",
        "semiAutomatedApiCapability": "Semi-automatisé avec capacité API",
        "manualApiCapability": "Manuel avec capacité API"
      },
      "useCases": {
        "title": "Sélectionnez votre/vos cas(s) d’utilisation",
        "tagText": "Chaque cas d’utilisation supplémentaire coûte 100€/mois.",
        "bodyText": "Veuillez sélectionner le(s) cas(s) d’utilisation pour votre participation à Catena-X. Vous devez en sélectionner au moins un ; Le premier cas d’utilisation est inclus par défaut dans votre abonnement. Vous pouvez en sélectionner autant que vous le souhaitez, avec des frais de 100 € appliqués pour chaque cas d’utilisation supplémentaire sélectionné en plus du premier."
      },
      "cancelModal": {
        "confirmQuestion": "Êtes-vous sûr que vous souhaitez annuler la connexion sélectionnée?",
        "confirmYes": "Oui, annuler",
        "confirmNo": "Non, continuer"
      },
      "enterprisePackage" : {
        "inputTitle" : "Message",
        "inputPlaceholder" : "Commencer à taper",
        "emptyErrorMessage" : "Le message ne peut pas être vide ou seulement des espaces",
        "validCharErrorMessage" : "Le message contient des caractères non valides",
        "noURLsErrorMessage" : "Le message ne peut pas contenir de liens ou d'URL",
        "limitRepeatsErrorMessage" : "Le message contient trop de caractères répétés"
      }
    },
    "statuses": {
      "complete": {
        "title": "Vous êtes déjà inscrit",
        "description": "Le lien d'enregistrement ne peut plus être utilisé.",
        "buttonText": "Aller vers la page d'accueil"
      },
      "error": {
        "title": "Quelque chose a mal tourné",
        "description": "Veuillez redémarrer le processus",
        "buttonText": "Redémarrage"
      },
      "expired": {
        "title": "Malheureusement, votre lien a expiré",
        "description": "Veuillez redémarrer le processus à partir du portail Catena-X.",
        "buttonText": "Retour à Catena-X"
      },
      "success": {
        "title": "Merci de votre inscription",
        "description": "Nous examinons les détails de votre organisation. Vous recevrez plus d'informations par e-mail.",
        "buttonText": "Aller sur notre site Web"
      },
      "invalid": {
        "title": "Non autorisé",
        "description": "Vous n'êtes pas autorisé à accéder à cette page.",
        "buttonText": "Aller sur notre site Web"
      },
      "dih-success": {
        "title": "Merci pour votre inscription",
        "description": "Nous examinons les détails de votre organisation. Vous recevrez plus d'informations par e-mail.",
        "buttonText": "Aller sur notre site Web"
      },
      "orgNotFound": {
        "title": "Nous n’avons pas trouvé votre organisation",
        "descriptionLine1": "Pardon! Il semble que votre organisation ne soit pas intégrée ou que vous n’ayez pas encore demandé d’abonnement aux services T-Systems.",
        "descriptionLine2": "Veuillez demander un abonnement aux services d’habilitation sur mesure et certifiés T-Systems pour Catena-X via la {marketplace}.",
        "marketplace": "marketplace",
        "descriptionLine3": "Si vous pensez qu’il s’agit d’une erreur, veuillez {contactOurSalesTeam} et nous serons heureux de vous aider.",
        "contactOurSalesTeam": "Contactez notre équipe commerciale",
        "exploreTheKnowledgeBase": "Explorez la base de connaissances",
        "readOurBlog": "Lire notre blog"
      },
      "ds-success": {
        "title": "Merci pour votre commande",
        "description": "Nous avons bien reçu les coordonnées de votre organisation.",
        "descriptionPara2": "Nous sommes en train d’examiner les détails et vous contacterons sous peu par e-mail.",
        "buttonText": "Démarrer"
      }
    },
    "orgExistLogin": {
      "title": "Vous avez déjà un compte chez Data Intelligence Hub ?",
      "action": "Connexion",
      "error": {
        "permissionErrorTitle": "Vous ne disposez pas des autorisations requises pour accéder à cette page.",
        "permissionErrorText": "Pour plus de détails, contactez l’administrateur de votre organisation",
        "orgNotFoundTitle": "Organisation introuvable",
        "orgNotFoundText": "Nous ne sommes pas en mesure d’identifier une organisation à partir de votre adresse e-mail. Veuillez remplir le formulaire d’inscription et fournir les détails de votre commande."
      }
    },
    "newOnboarding": {
      "address": {
        "country": "Pays*",
        "region": "Région*",
        "street": "Rue*",
        "number": "Numéro*",
        "postCode": "Code postal*",
        "city": "Ville*",
        "organisationAddress": "Adresse de l’organisation",
        "organisationAddressSubheading": "Veuillez saisir l’adresse de votre organisation",
        "billingAddress": "Adresse de facturation",
        "billingAddressSubheading": "Veuillez saisir votre adresse de facturation",
        "sameAsOrgAddress": "Mon adresse de facturation est la même que l’adresse de l’organisation."
      },
      "organisationInformation": "Informations sur l’organisation",
      "organisationInformationSubheading": "Veuillez saisir les informations de votre organisation",
      "organisationName": "Nom légal de l’organisation",
      "organisationNameInfo": "Veuillez saisir le nom légalement contraignant de l’organisation",
      "transliteratedName": "Nom translittéré (Caractères latins)",
      "transliteratedNameInfo": "Optionnel : Saisissez le nom en utilisant des caractères latins pour aider nos réviseurs. Il ne doit pas nécessairement s’agir d’un nom officiel.",
      "transliteratedNamePrompt": "Votre nom légal est dans un système d'écriture non latin. Veuillez envisager de fournir une translittération en caractères latins afin d'aider nos réviseurs.",
      "transliteratedNameValidationMsg": "Veuillez fournir une translittération en alphabet latin afin d’aider nos réviseurs.",
      "contactDetailsHeading": "Coordonnées",
      "contactDetailsSubheading": "Veuillez saisir vos coordonnées",
      "firstName": "Prénom*",
      "lastName": "Nom de famille*",
      "emailAddress": "Adresse e-mail*",
      "phoneNumber": "Numéro de téléphone*",
      "companyIdentifierHeading": "Identifiant de l’organisation",
      "companyIdentifierSubheading": "Entrez au moins un des identifiants uniques suivants pour continuer*",
      "identifierType": "Type d’identifiant*",
      "identifierValue": "Valeur de l’identifiant*",
      "identifierTypeError": "Veuillez sélectionner un type d’identifiant",
      "identifierValueError": "La valeur de l’identifiant est requise",
      "identifierValueFormatError": "Format non valide. Exemple : {field}"
    }
  },
  "dashboard": {
    "pageTitle": "Accueil",
    "pageSubtitle": "Ceci est votre centre de contrôle pour tout dans Data Intelligence Hub."
  },
  "services": {
    "finishConfig": "Configuration de la fin",
    "open": "Ouvrir",
    "viewDetails": "Afficher les détails",
    "configure": {
      "uploadCertification": "Veuillez télécharger le certificat qui vous a été envoyé par l'opérateur du Dataspace.",
      "dragAndDropCertificate": "Faites glisser et déposez votre fichier de certificat ici.",
      "didntReceive": "Vous n'en avez pas reçu ou vous ne savez pas comment en obtenir un? Suivez les étapes ici",
      "uploadSuccessMessage": "Certificat téléchargé avec succès"
    },
    "table": {
      "attribute": "Attribut",
      "value": "Valeur",
      "apiKey": "Clé API",
      "apiKeyValue": "Valeur de la clé d’API",
      "controlPlaneUrl": "URL du plan de contrôle",
      "idsURL": "Point de terminaison de l’API DSP",
      "connectorUrl": "URL du connecteur",
      "dataManagementUrl": "Point de terminaison de l’API de gestion des données",
      "dataDashboard": "Tableau de bord de données",
      "participantDid": "ID DID du participant"
    }
  },
  "dataspaces": {
    "dataspaces": "Dataspaces",
    "connectorTestDescription": "Application pour tester si votre connexion fonctionne comme prévu et si votre connexion à l'espace de données est active.",
    "viewAllDataspaces": "Afficher tous les espaces de données",
    "managedConnectorsHeading": "Managed connector(s)",
    "externalConnectorsHeading": "External connector(s)",
    "configure": {
      "pageTitle": "Configurer la connexion Dataspace",
      "basicInfo": "Informations de base",
      "certificate": "Certificat",
      "instructionCertrificate": "Veuillez télécharger le certificat que vous avez reçu de l'opérateur de Dataspace."
    },
    "connectorHealthCheck": {
      "title": "Vérification de l'état du connecteur",
      "copiedToClipboard": "Copié dans le presse-papier",
      "description": "Avec l'aide de cette application, un autotest est effectué pour vérifier si le connecteur que vous avez sélectionné est configuré et fonctionne comme prévu. Cela ne modifiera aucun paramètre ni stockage du connecteur sélectionné.",
      "connectorid": "ID du connecteur",
      "model": {
        "title": "Vérification de l'état du connecteur en cours...",
        "body": "Vous ne pouvez pas partir pendant que le bilan de santé est en cours. Si vous souhaitez partir, le bilan de santé sera interrompu et devra être relancé.",
        "toLeave": "Non, je veux partir",
        "toFinish": "Terminer le bilan de santé"
      },
      "banner": {
        "initiate": "L’exécution du contrôle de santé peut prendre quelques minutes. Vous serez averti dès que le résultat sera disponible.",
        "success": "Votre autotest Connect a réussi ! Pour afficher les résultats des tests antérieurs, cliquez sur Résultats ci-dessus.",
        "failed": "Désolé! Votre autotest Connect a échoué. Veuillez contacter {email} et nous serons heureux de vous aider.",
        "email": "dih.support{'@'}telekom.com"
      },
      "buttonState": {
        "initiate": "Lancer",
        "success": "Ouvrir la connexion",
        "failed": "Contactez le support",
        "back": "dos"
      }
    },
    "browse": {
      "browseDataspace": "Parcourir les données",
      "availableDS": "Dataspaces disponibles",
      "howToConnect": "Comment se connecter",
      "getConnected": "Se connecter",
      "requestConnection": "Demande de connexion",
      "viewRequest": "Voir la demande",
      "viewDetails": "Afficher les détails",
      "highlightNote": "Si vous souhaitez gérer votre abonnement avec {selectedDataspaceName}, veuillez contacter notre support:",
      "uncoverByInvitation": "Découvrir par invitation",
      "dataspaceDetails": "Détails de l'espace de données",
      "participantOverview": "Aperçu des participants",
      "services": "Services",
      "networking": "réseautage",
      "networkingDesc": "Cet espace de données peut restreindre l’accès réseau à ses services et connecteurs par la plage d’adresses IP autorisées. Au cas où votre application rencontrerait des problèmes, veuillez contacter l’administrateur de votre espace de données pour mettre en liste blanche votre adresse/plage IP actuelle.",
      "networkingIPTitle": "Mon adresse IP (Navigateur)",
      "networkingInfoText": "Si votre application s’exécute sur un appareil séparé, vous pouvez vous connecter à cet appareil et émettre une commande telle que",
      "networkingCurlCommand": "“curl --location 'ifconfig.me/ip”",
      "networkingHighlightNote": "Pour toute question, veuillez contacter notre support :",
      "joinRequestSuccessTitle": "Votre demande d’adhésion au {dataspaceName} a été soumise",
      "joinRequestSuccessBody": "Vous obtiendrez de plus amples informations une fois votre demande traitée",
      "dataspaceMembershipId": "ID d’appartenance à l’espace de données",
      "uncover": {
        "title": "Afficher un Dataspace par invitation",
        "subtitle": "Quel Dataspace recherchez-vous?",
        "fieldLabels": "Entrez les détails fournis par l'opérateur de Dataspace",
        "sendRequest": "Envoyer une demande",
        "back": "Retour",
        "dataspaceId": "ID de Dataspace",
        "password": "Mot de passe"
      },
      "requestDetailsModal": {
        "withdraw": "Retirer",
        "cancel": "Annuler",
        "update": "Mise à jour",
        "withdrawConfirmationHeading": "Retirer une demande de jointure à l’espace de données",
        "withdrawConfirmationBody": "Veuillez reconfirmer que vous avez l’intention de retirer votre demande d’adhésion à l’espace de données {dataspaceName}.",
        "notification": {
          "withdrawSuccessfulTitle": "Demande de jointure d’espace de données retirée",
          "withdrawSuccessfulBody": "Votre demande d’adhésion à {dataspaceName} a été retirée.",
          "updateSuccessfulTitle": "Mise à jour de la demande de jointure à l’espace de données",
          "updateSuccessfulBody": "Votre demande d’adhésion à {dataspaceName} a été mise à jour."
        }
      }
    },
    "user": {
      "myMemberships": "Mes adhésions",
      "enterDS": "Entrez l'espace de données",
      "registeredDS": "Vos Dataspaces",
      "noMembership": {
        "title": "Vous n'avez pas encore d'adhésion",
        "description": "Parcourir les données pour rejoindre un Dataspace",
        "actionButtonText": "Se connecter"
      }
    },
    "statuses": {
      "attentionRequired": "Attention requise",
      "comingSoon": "Disponible prochainement",
      "connected": "Connecté",
      "disconnected": "Déconnecté",
      "deploying": "Déploiement",
      "deployed": "Déployé",
      "failed": "Échoué",
      "available": "Disponible",
      "success": "Succès"
    }
  },
  "verify": {
    "orgProfile": "Profil d'organisation",
    "legalName": "Nom légal",
    "address": "Adresse",
    "contact": "Contact",
    "vatID": "numéro de TVA",
    "requestChange": "Demander un changement",
    "downloadVCMessage": "VC téléchargé avec succès",
    "placeholderEnterSelectInput": "Entrez ou sélectionnez une valeur dans la liste",
    "vcOverview": {
      "masterHeading": "Types de références",
      "credentialTypeCards": {
        "description": {
          "legalPerson": "Il s'agit d'une représentation numérique des informations de l'entité juridique, telles que les détails d'enregistrement, l'identification de l'entreprise ou le statut juridique de l'organisation",
          "serviceOffering": "Il s'agit d'un ensemble d'actifs et de ressources qu'un Fournisseur combine dans un package pour offrir aux Consommateurs",
          "physicalResource": "Il s'agit d'une ressource avec un poids mesurable et une position spatiale, représentant une entité tangible qui sert d'hôte, de manipulateur ou de participant aux interactions avec d'autres entités physiques",
          "softwareResource": "Il s'agit d'un type d'actif qui comprend des fonctionnalités non physiques telles que le code source",
          "dataResource": "Il s'agit d'un type d'actif qui se compose de données (y compris y compris les données dérivées) sous n'importe quelle forme et comprend les informations nécessaires au partage des données"
        },
        "cta": {
          "enter": "Entrer"
        }
      },
      "credentialOverview": "Vue d'ensemble des informations d'identification",
      "credentialErrorMessage": "Erreur lors de la récupération des informations d'identification {type}",
      "searchByNamePlaceholder": "Recherche par nom",
      "credentialErrorDetailsMessage": "Actuellement, nous rencontrons des difficultés techniques lors de la récupération des informations d'identification, veuillez réessayer après un certain temps"
    },
    "verifiableCredentials": {
      "getVerified": "Être vérifié",
      "credentials": "Informations d'identification",
      "requestCredential": "Demander un certificat",
      "whichTypeToSelect": "Quel type dois-je sélectionner ?",
      "noCredentialsMessage": "Vous n'avez pas encore d'informations d'identification {type}",
      "credentialInfoMessage": "L'ajout d'identification augmentera votre niveau de confiance parmi les participants d'un écosystème.",
      "credentialModalMessage": "Vos références sont les qualifications ou des informations qui établissent l'identité, l'expertise ou la légitimité d'une entreprise.",
      "learnMore": "En savoir plus",
      "status": {
        "all": "Tous",
        "valid": "Valide",
        "expired": "Expiré",
        "revoked": "Révoqué"
      },
      "types": {
        "legalPerson": "Identification de l'entreprise",
        "serviceOffering": "Conformité et certification",
        "physicalResource": "Ressources matérielles",
        "dataResource": "Ressources de données",
        "softwareResource": "Ressources logicielles",
        "membership": "Adhésion"
      },
      "form": {
        "type": {
          "placeholder": "Choisissez votre type",
          "label": "Choisissez votre type",
          "error": "Choisissez votre type est requis"
        },
        "types": {
          "legalPerson": "Personne légal",
          "serviceOffering": "Offres de service",
          "physicalResource": "Ressource physique",
          "resource": "Ressource",
          "dataResource": "Ressource de données",
          "softwareResource": "Ressource logicielle"
        },
        "companyInformationSectionTitle": "Informations sur la société",
        "companyInformationSectionSubtitle": "Veuillez saisir les informations de votre entreprise",
        "legalName": {
          "label": "Nom légal de l'organisation",
          "helpText": "Veuillez utiliser le nom juridiquement contraignant de l'organisation"
        },
        "country": {
          "placeholder": "Choisissez le pays",
          "label": "Pays",
          "error": "Le pays est requis"
        },
        "region": {
          "placeholder": "Choisissez une région",
          "label": "Région",
          "error": "La région est obligatoire"
        },
        "street": {
          "label": "Rue et numéro de maison"
        },
        "city": {
          "label": "Ville"
        },
        "postalCode": {
          "label": "Code postal"
        },
        "commercialIdentificationSectionTitle": "Identification commerciale",
        "commercialIdentificationSectionSubtitle": "Entrez au moins l'un des ID uniques suivants pour continuer *",
        "CRN": {
          "label": "Numéro de registre commercial",
          "helpText": "Exemple: HRB 55933",
          "tooltipText": "Le numéro de registre commercial (CRN) est un identifiant unique attribué aux entreprises pour leur enregistrement commercial légal. Il est utilisé pour valider et vérifier l'authenticité des identifiants d'enregistrement et de transaction financière d'une entreprise contre les sources de données de confiance."
        },
        "vatId": {
          "label": "numéro de TVA",
          "helpText": "Exemple: DE 118 645 675",
          "tooltipText": "Un numéro de TVA (numéro d'identification fiscale à valeur ajoutée) est un identifiant unique attribué aux entreprises à des fins fiscales."
        },
        "eori": {
          "label": "EORI",
          "helpText": "Exemple: DE 103 280 493 572",
          "tooltipText": "EORI (numéro d'enregistrement et d'identification de l'opérateur économique) est un identifiant unique attribué aux opérateurs économiques engagés dans le commerce international au sein de l'Union européenne (UE)."
        },
        "lei": {
          "label": "LEI",
          "helpText": "Exemple: 5299009d9bil4d4uht93",
          "tooltipText": "LEI (identifiant d'entité juridique) est un code d'identification unique attribué aux entités juridiques engageant des transactions financières impliquées sur les marchés financiers mondiaux."
        },
        "didSectionTitle": "Identifiant décentralisé (DID)",
        "didSubSectionTitle": "Si vous n'avez pas de DID, veuillez laisser ce champ vide, il sera généré automatiquement.",
        "did": {
          "label": "Objet du certificat (DID)",
          "helpText": "did:example123456789abcd",
          "tooltipText": "Un DID est un identifiant unique qui peut être résolu en un document DID. Les DID sont les éléments fondamentaux de l'identité numérique décentralisée."
        },
        "certificate": {
          "error": "Un certificat est requis"
        },
        "request": "Demande",
        "requesting": "Demander...",
        "certificateSectionHeading": "Signature",
        "certificateSectionTitle": "Quel certificat souhaitez-vous utiliser pour signer?",
        "addCertificate": "Ajouter un nouveau certificat",
        "chooseCertificate": "Choisissez votre certificat",
        "tsystemsCertificate": "Certificat T-Systems",
        "yourCertificate": "Votre certificat",
        "consentTooltip": "En sélectionnant cette option, vous autorisez T-Systems à signer le document ci-dessus en votre nom. Pour plus de détails, veuillez consulter la documentation",
        "consentPersonalData": "Je suis d'accord et confirme par la présente que toutes mes informations personnelles et données (\"données personnelles\") indiquées ci-dessus sont exactes.",
        "consentProcessing": "J'autorise par la présente Gaia-X à traiter toutes mes données  (y compris toutes les données sensibles personnelles)."
      },
      "vcRequestSuccess": "La demande a été soumise avec succès",
      "selectAllButton": "Tout sélectionner",
      "deselectAllButton": "Tout déselectionner",
      "revokeButton": "Révoquer",
      "searchboxPlaceholder": "Entrez au moins 3 caractères",
      "credentialTile": {
        "issuedBy": "Délivré par",
        "issuedOn": "Publié le",
        "expiresOn": "Expire le",
        "expiredOn": "A expiré le",
        "viewDetailsButton": "Afficher les détails"
      },
      "revokeModal": {
        "heading": "Confirmer la révocation",
        "question": "Êtes-vous sûr de vouloir révoquer l'article?",
        "note": "Remarque:",
        "message": "Après avoir révoqué un diplôme, il devient invalide et ne peut plus être utilisé. Pour obtenir un diplôme valide, vous devrez en demander un nouveau.",
        "primaryButton": "Révoquer",
        "secondaryButton": "Annuler"
      },
      "deleteCredential": {
        "heading": "Supprimer la confirmation",
        "question": "Êtes-vous sûr de vouloir supprimer les informations d'identification ?",
        "deleteSuccess": "Informations d'identification supprimées avec succès"
      },
      "credentialsDetailsModal": {
        "heading": "Détails du titre",
        "selfDescriptionCredential": "Informations d'auto-description",
        "type": "Veuillez taper",
        "id": "identifiant",
        "issuer": "émetteur",
        "issuanceDate": "émis",
        "expirationDate": "date d'expiration",
        "credentialSubject": "credentialSubject",
        "bpn": "CTXSD: BPN",
        "participantName": "GX-participant: nom",
        "participantNameLegalName": "GX-participant: nom légal",
        "legalRegistrationNumber": "GX: Participant: Legal RegistrationNumber",
        "EUID": "GX: EUID",
        "leiCode": "GX: Leicode",
        "vatID": "GX: Vatid",
        "registrationNumberType": "GX: Enregistrement",
        "registrationNumberNumber": "GX: Enregistrement",
        "headquarterAddress": "GX: Participant: le siège social",
        "addressCountryCode": "GX: AddressCountrycode",
        "countrySubdivisionCode": "gx:countrySubdivisionCode",
        "locality": "GX: localité",
        "streetAddress": "GX: StreetAddress",
        "legalAddress": "GX: Participant: LegalAddress",
        "termsAndConditions": "GX-participant: termes et conditions",
        "serviceOfferingName": "gx:serviceOfferingName",
        "serviceOfferingDescription": "gx:serviceOfferingDescription",
        "providedBy": "gx:providedBy",
        "aggregationOf": "gx:aggregationOf",
        "aggregationOfId": "gx:id",
        "policy": "gx:policy",
        "serviceOfferingTermsAndConditions": "gx:termsAndConditions",
        "url": "gx:URL",
        "hash": "gx:hash",
        "dataAccountExport": "gx:dataAccountExport",
        "requestType": "gx:requestType",
        "accessType": "gx:accessType",
        "formatType": "gx:formatType",
        "proof": "Preuve",
        "created": "créé",
        "proofPurpose": "proofPurpose",
        "verificationMethod": "verificationMethod",
        "jws": "jws",
        "status": "Statut",
        "primaryButton": "Télécharger",
        "secondaryButton": "Annuler",
        "resourceName": "gx:name",
        "resourceDescription": "gx:description",
        "resourceCopyrightOwnedBy": "gx:copyrightOwnedBy",
        "resourceExposedThrough": "gx:exposedThrough",
        "resourceProducedBy": "gx:producedBy",
        "resourcePolicy": "gx:policy",
        "resourceLicense": "gx:license",
        "resourceContainsPII": "gx:containsPII",
        "resourceMaintainedBy": "gx:maintainedBy",
        "resourceOwnedBy": "gx:ownedBy",
        "resourceManufacturedBy": "gx:manufacturedBy",
        "resourceCountryCode": "Indicatif du pays",
        "resourceLocality": "Localité",
        "resourcePostalCode": "Code postal",
        "resourceStreetAddress": "Adresse postale",
        "legalPersonRegistrationNumber": "gx:lagelRegistrationNumber"
      },
      "notificationText": "Désolé, nous n'avons trouvé aucun résultat correspondant à vos critères de recherche. Veuillez affiner votre recherche et réessayer.",
      "bulkUpload": {
        "title": "Valider vos partenaires",
        "helpText": "Validez vos partenaires commerciaux d'un seul coup en remplissant le modèle fourni",
        "uploadFileTitle": "Téléverser un fichier",
        "requestCredentials": "Demander des informations d'identification",
        "uploadFormHelpHeading": "Pour valider plusieurs entreprises, procédez de la manière suivante :",
        "uploadFormHelpText1": "Téléchargez le fichier de modèle à partir du lien ci-dessous",
        "uploadFormHelpText2": "Remplissez le fichier fourni avec les détails de vos partenaires commerciaux",
        "uploadFormHelpText3": "Déposez le fichier dans la zone de téléchargement ci-dessous",
        "downloadTemplateBtn": "Télécharger le modèle",
        "partnerValidationHelpText": "Si vous souhaitez en savoir plus sur la validation des partenaires, veuillez",
        "partnerValidationHelpLink": "Cliquez ici",
        "uploadFile": {
          "uploadFileHeading": "Sélectionnez un fichier CSV à télécharger"
        },
        "vcProcessingTitle": "Traitement des dossiers",
        "bulkVcContinueBtn": "Continuer",
        "issuingProgressMessage": "La délivrance des accréditations est en cours...",
        "doNotCloseWarning": "S'il vous plaît, ne fermez pas le formulaire tant que le traitement n'est pas terminé.",
        "bulkVcDownloadReportBtn": "Télécharger le rapport",
        "successMessage": "Complété avec succès!",
        "failedErrorMessage": "Erreurs dans les entrées {result}",
        "processAbortTitle": "Traitement",
        "processAbortDescription": "Êtes-vous sûr de vouloir arrêter le traitement?",
        "stopProcessingBtn": "Arrêter le traitement"
      },
      "validation": {
        "vatId": {
          "field": "Veuillez entrer un numéro de TVA valide. ",
          "AT": "Indice : Doit commencer par 'ATU' suivi de 8 chiffres.",
          "BE": "Indice : Doit commencer par 'BE' suivi de 10 chiffres.",
          "BG": "Indice : Doit commencer par 'BG' suivi de 9 ou 10 chiffres.",
          "CY": "Indice : Doit commencer par 'CY' suivi de 8 chiffres et 1 lettre.",
          "CZ": "Indice : Doit commencer par 'CZ' suivi de 8 à 10 chiffres.",
          "DE": "Indice : Doit commencer par 'DE' suivi de 9 chiffres.",
          "DK": "Indice : Doit commencer par 'DK' suivi de 8 chiffres.",
          "EE": "Indice : Doit commencer par 'EE' suivi de 9 chiffres.",
          "EL": "Indice : Doit commencer par 'EL' suivi de 9 chiffres.",
          "ES": "Indice : Doit commencer par 'ES' suivi d'un mélange de lettres et de chiffres.",
          "FI": "Indice : Doit commencer par 'FI' suivi de 8 chiffres.",
          "FR": "Indice : Doit commencer par 'FR' suivi de 2 lettres et 9 chiffres.",
          "HR": "Indice : Doit commencer par 'HR' suivi de 11 chiffres.",
          "HU": "Indice : Doit commencer par 'HU' suivi de 8 chiffres.",
          "IE": "Indice : Doit commencer par 'IE' suivi d'une combinaison complexe de chiffres et de lettres.",
          "IT": "Indice : Doit commencer par 'IT' suivi de 11 chiffres.",
          "LT": "Indice : Doit commencer par 'LT' suivi de 9 à 12 chiffres.",
          "LU": "Indice : Doit commencer par 'LU' suivi de 8 chiffres.",
          "LV": "Indice : Doit commencer par 'LV' suivi de 11 chiffres.",
          "MT": "Indice : Doit commencer par 'MT' suivi de 8 chiffres.",
          "NL": "Indice : Doit commencer par 'NL' suivi de 9 chiffres et 'B' + 2 chiffres.",
          "PL": "Indice : Doit commencer par 'PL' suivi de 10 chiffres.",
          "PT": "Indice : Doit commencer par 'PT' suivi de 9 chiffres.",
          "RO": "Indice : Doit commencer par 'RO' suivi de 2 à 10 chiffres.",
          "SE": "Indice : Doit commencer par 'SE' suivi de 12 chiffres.",
          "SI": "Indice : Doit commencer par 'SI' suivi de 8 chiffres.",
          "SK": "Indice : Doit commencer par 'SK' suivi de 10 chiffres.",
          "XI": "Indice : Doit commencer par 'XI' suivi de 9 chiffres."
        },
        "eori": "Veuillez entrer un EORI valide. Indice : Il doit commencer par 2 lettres majuscules suivies de 9 à 15 chiffres.",
        "lei": "Veuillez entrer un LEI valide. Indice : Il doit comporter 20 caractères, les 18 premiers alphanumériques en majuscules et les 2 derniers chiffres.",
        "did": "Veuillez entrer un DID valide. Il doit commencer par 'did:', suivi de méthode et de segments séparés par des deux-points, en utilisant uniquement des lettres, des chiffres, '%', '.', '_', et '-'.",
        "hash": "Veuillez entrer un hash SHA-256 valide. Il doit comporter exactement 64 caractères hexadécimaux (0-9, A-F).",
        "format_type": "Veuillez saisir un type de format valide. Il doit s'agir d'un mot suivi d'un « / » puis d'une chaîne de caractères valide (lettres, chiffres, « - », « + », « . » ou « _ »)"
      }
    },
    "serviceOfferingForm": {
      "generalInformationHeading": "Informations générales",
      "labelSOName": "Nom de l'offre de service",
      "labelProvidedBy": "Fourni par",
      "labelSODescription": "Description de l'offre de service",
      "hintSOName": "Nom lisible par l'homme de l'offre de service",
      "hintProvidedBy": "Lien résoluble sous forme DID vers l'auto-description du participant fournissant le service",
      "hintSODescription": "Une liste de politiques exprimées à l'aide de DSL (par exemple, Rego ou ODRL, contrôle d'accès, limitation, utilisation, rétention, …)",
      "resourcesHeading": "Ressources",
      "labelSOResources": "Auto-description de la ressource",
      "hintSOResources": "Lien résoluble sous forme DID d'auto-description de ressource, qui est lié au service et peut exister indépendamment de celui-ci",
      "termsAndConditionsHeading": "Termes et conditions",
      "labelUrlSO": "URL",
      "labelHashSO": "Hash",
      "labelSOPolicy": "Politique",
      "policyTooltip": "Lien résolvable vers la Politique s'appliquant à l'Offre de service",
      "termsAndConditionsTooltip": "Lien résoluble vers les Conditions Générales applicables à l'Offre de Service",
      "personalDEHeading": "Exportation de données personnelles",
      "personalDETooltip": "Permet aux clients du service d'exporter des données personnelles et non personnelles hors du service.",
      "labelRequestTypeSO": "Type de demande",
      "labelAccessTypeSO": "Type d'accès",
      "placeholderRequestTypeSO": "Sélectionnez le type de demande",
      "placeholderAccessTypeSO": "Sélectionnez le type d'accès",
      "labelFormatTypeSO": "Type de format",
      "hintRequestTypeSO": "Le moyen de demander la récupération des données : API, email, formulaire Web, unregisteredLetter, approvedLetter, supportCenter",
      "hintAccessTypeSO": "Type de support de données : numérique, physique",
      "hintFormatTypeSO": "Type de types de médias (types MIME) tels que définis par",
      "consentTC1": "J'accepte et confirme par la présente que toutes les données saisies indiquées ci-dessus sont exactes",
      "consentTC2": "Par la présente, j'accepte et autorise T-Systems à traiter mes données (y compris toutes les données personnelles sensibles)",
      "consentTC3": "J'accepte par la présente le",
      "gaiaXTermsText": "Conditions générales de Gaia-X",
      "requestTypesList": {
        "api": "API",
        "email": "E-mail",
        "webform": "Formulaire Web",
        "unregisteredLetter": "Lettre non recommandée",
        "registeredLetter": "Lettre recommandée",
        "supportCenter": "Centre de soutien"
      },
      "requestTypesError": "Le type de demande est requis",
      "accessTypesList": {
        "digital": "Numérique",
        "physical": "Physique"
      },
      "accessTypesError": "le type d'accès est requis",
      "helpSOName": "Veuillez saisir un nom lisible par l'homme de votre service",
      "helpProvidedBy": "Identifiant décentralisé du Participant fournissant le service",
      "helpSOResources": "Identificateurs décentralisés des ressources exposées par le biais de ce service",
      "helpUrlSO": "Veuillez saisir le lien vers votre document CGV (par ex. https://service.com/terms)",
      "helpHashSO": "Veuillez saisir un hachage sha256 de votre document CGV",
      "helpPolicySO": "Veuillez saisir une politique exprimée à l'aide d'un DSL (par exemple, Rego ou ODRL)",
      "helpRequestTypeSO": "Veuillez sélectionner un type de demande dans la liste déroulante",
      "helpAccessTypeSO": "Veuillez sélectionner un type d'accès dans la liste déroulante",
      "helpFormatTypeSO": "Veuillez saisir le type MIME (par exemple, application/json)"
    },
    "resourceForm": {
      "generalInformationHeading": "Informations générales",
      "generalInformationSubHeading": "Veuillez entrer les informations générales de votre ressource",
      "labelResourceType": "Type de ressource",
      "placeholderResourceType": "Sélectionner le type de ressource",
      "errorResourceType": "Le type de ressource est requis",
      "labelResourceName": "Nom de la ressource",
      "labelResourceDescription": "Description de la ressource",
      "hintResourceType": "Type de ressource décrite",
      "hintResourceName": "Nom lisible par l'homme de la ressource",
      "hintResourceDescription": "Description lisible par l'homme de la ressource",
      "physicalResource": "Ressource physique",
      "softwareResource": "Ressource logicielle",
      "dataResource": "Ressource de données",
      "additionalInformationHeading": "Informations complémentaires",
      "additionalInformationSubHeading": "Veuillez saisir les informations supplémentaires sur votre ressource",
      "labelMaintainedBy": "Maintenu par",
      "hintMaintainedBy": "Lien résolvable vers Gaia-X Credential du participant maintenant la ressource en condition opérationnelle et ayant ainsi un accès physique à celle-ci",
      "labelOwnedBy": "Propriété de",
      "hintOwnedBy": "Lien résolvable vers Gaia-X Identifiant du participant propriétaire de la ressource",
      "labelManufacturedBy": "Fabriqué par",
      "hintManufacturedBy": "Lien résolvable vers Gaia-X Identifiant du participant fabriquant la ressource",
      "labelCountry": "Pays",
      "hintCountry": "Pays dans lequel se trouve la ressource",
      "labelCity": "Ville",
      "hintCity": "Ville où se trouve la ressource",
      "labelPostCode": "Code postal",
      "hintPostCode": "Code postal dans lequel se trouve la ressource",
      "labelStreet": "Rue",
      "hintStreet": "Numéro de maison et rue dans lesquels se trouve la ressource",
      "labelCopyrightOwnerBy": "Titulaire du droit d'auteur par",
      "hintCopyrightOwnerBy": "Un titulaire de droit d'auteur est une personne ou une organisation qui a le droit d'exploiter la ressource. Le titulaire du droit d'auteur ne fait pas nécessairement référence à l'auteur de la ressource, qui est une personne physique et peut différer du titulaire du droit d'auteur. Exprimé soit sous forme de texte libre, soit sous forme de lien résolvable vers Gaia-X Credential du propriétaire du droit d'auteur.",
      "labelLicense": "Licence",
      "hintLicense": "URL du document de licence ou de l'une des licences de la page",
      "labelPolicy": "Politique",
      "hintPolicy": "Une liste de politiques exprimées à l'aide d'un DSL (par exemple, Rego ou ODRL) (contrôle d'accès, limitation, utilisation, rétention, ...). Si la contrainte de stratégie est omise, il est supposé que l'utilisation est autorisée à tous les participants",
      "labelProducedBy": "Produit par",
      "hintProducedBy": "Lien résolvable vers l'identifiant Gaia-X du participant permettant légalement l'utilisation des données.",
      "labelExposedThrough": "Exposé à travers",
      "hintExposedThrough": "Lien résolvable vers le composant d'échange de données qui a exposé la ressource de données",
      "locationHeading": "Détails de l'emplacement",
      "locationSubHeading": "Veuillez saisir les détails de l'emplacement de votre ressource",
      "licenseTooltipText": "Liste des licences SPDX",
      "licenseTooltipLink": "https://spdx.org/licenses/",
      "consentPII": "Je confirme par la présente que la ressource de données ne contient pas d'informations personnelles identifiables (PII)."
    },
    "verifyLanding": {
      "heading": "Bienvenue à “Get verified”",
      "subHeading": "Augmentez la confiance de votre écosystème numérique !",
      "description1": "Vous souhaitez vérifier et valider vos partenaires commerciaux, ou vous souhaitez présenter vos propres identifications et vérifications ? Ensuite, vous devez demander vos premières informations d'identification vérifiables ‚Äì nos informations numériques. Produit d'identification.",
      "description2": "Les informations d'identification vérifiables peuvent contenir les mêmes informations que celles de vos identités physiques (par exemple carte d'identité, permis de conduire) et encore plus d'attributs. L'ajout de technologies, telles en tant que signatures numériques, rend les informations d'identification vérifiables plus inviolables et plus fiables que leurs homologues physiques.",
      "description3": "T-Systems fonctionne comme l'un des premiers nœuds de compensation numérique Gaia-X et émet vos preuves numériques conformément aux spécifications du Gaia-X Trust Framework. De plus, nous ajoutons notre signature numérique conforme eIDAS de notre partenaire Telekom Security.",
      "requestButton": "Demander Digital.ID",
      "digitalID": "Digital.ID produit.",
      "consultation": {
        "heading": "Demandez vos identifiants ou validez vos partenaires",
        "placeholder": "Avez-vous une expérience antérieure avec des informations d'identification vérifiables ? Intéressé par vos premiers diplômes ?"
      },
      "sendAnotherRequest": "Envoyer une autre demande",
      "lastRequest": "Votre dernière demande a été envoyée le"
    },
    "getInsights": {
      "tab1": "Rapports",
      "tab2": "Limites d'utilisation de l'API",
      "tab3": "Intégration technique",
      "monthsByOptions": {
        "option1": "3 mois",
        "option2": "6 mois",
        "option3": "1 mois"
      },
      "table": {
        "heading2": "Période de référence",
        "heading3": "Créé à",
        "heading4": "Actions"
      },
      "successDownload": "Rapport(s) téléchargé(s) avec succès",
      "errorDownload": "Le téléchargement de votre fichier pour {filename} a été interrompu avec une erreur. Veuillez réessayer.",
      "apiUsageLimit": {
        "requestNameTitle": "Nom de la demande",
        "dailyTitle": "Requêtes API quotidiennes",
        "monthlyTitle": "Requêtes API mensuelles",
        "limitexhaustedWarning": "Moins de 10 % des demandes restantes",
        "limitExtentionHeading": "Demander une extension de limite",
        "limitExtentionPlaceholder": "Intéressé par l'extension de vos limites d'utilisation de l'API ?",
        "supportBtn": "Soutien",
        "limitExtentionText": "Sur le point d'atteindre la limite ? Contactez-nous et réglons cela !"
      },
      "addIntegration": "Ajouter une intégration",
      "integrationData": {
        "clientId": "Client ID",
        "createdAt": "Créé à",
        "actions": "Actions"
      }
    },
    "addIntegration": {
      "generalInformationHeading": "Informations générales",
      "addAnIntegration": "Ajouter une intégration",
      "clientName": "Nom du client",
      "clientId": "ID client",
      "clientSecret": "Secret client",
      "tokenUrl": "URL du jeton",
      "pcCallbackUrl": "URL de rappel des identifiants des participants",
      "soCallbackUrl": "URL de rappel des identifiants de l'offre de service",
      "digitalIdAuthenticateInfo1": "Comment la Validation de Digital.ID s'authentifiera-t-elle contre votre système?",
      "digitalIdAuthenticateInfo2": "Comment la Conformité de Digital.ID s'authentifiera-t-elle contre votre système?",
      "seeResults": "Où devons-nous envoyer les résultats?",
      "requestSuccess": "ajouté avec succès",
      "callbackSuccess": "Callback ajouté avec succès",
      "step1Name": "Détails d'authentification de validation",
      "step2Name": "Détails d'authentification de conformité",
      "step3Name": "Informations de rappel",
      "deleteSuccess": "Supprimé avec succès",
      "downloadSuccess": "Téléchargé avec succès",
      "editCallbackHeading": "Ajouter un rappel",
      "deleteModal": {
        "heading": "Supprimer la confirmation",
        "deleteContent": "Êtes-vous sûr de vouloir supprimer le client ?",
        "deleteNote": "Après avoir supprimé un client, il disparaîtra de la liste et ne pourra plus être utilisé. Pour le restaurer, vous devrez recréer à partir de zéro."
      }
    },
    "mySignatures": {
      "certificatesOrdering": {
        "heading": "Bienvenue dans \"Mes signatures\"",
        "subHeading": "Vous souhaitez demander un certificat numérique qui vous permette de signer vos revendications ?",
        "description1": "Avec notre produit Digital.ID, vous pouvez facilement demander votre premier certificat et commencer à profiter des avantages des collaborations numériques sécurisées.",
        "description2": "Les informations d'identification vérifiables peuvent contenir les mêmes informations que vos identifiants physiques, tels que les cartes d'identité et les permis de conduire, et bien plus encore. Au cours du processus d'émission, vous confirmerez l'exactitude de vos informations en les signant avec votre propre certificat digne de confiance.",
        "description3": "Vous pouvez demander et maintenir vos certificats numériques en toute sécurité pour tous vos besoins de signature. Nous travaillons exclusivement en partenariat avec des fournisseurs de certificats numériques certifiés, garantissant que vos certificats numériques sont à la fois sécurisés et dignes de confiance.",
        "requestButton": "Demander un certificat",
        "consultation": {
          "heading": "Demander un certificat",
          "placeholder": "Veuillez saisir les détails nécessaires à votre demande"
        }
      },
      "certificateOverview": {
        "heading": "Mes signatures",
        "requestCertificateCTA": "Demander un certificat",
        "placeholderCertificateType": "Type de certificat",
        "placeholderCertificateStatus": "Statut du certificat",
        "EVSSL": "EV SSL",
        "EIDAS": "EIDAS",
        "headingEVSSL": "Certificats SSL EV",
        "headingEIDAS": "Certificats EIDAS",
        "certificateDetailsHeading": "Détails du certificat",
        "certificateName": "Nom",
        "certificateId": "ID",
        "certificateType": "Type",
        "provider": "Prestataire",
        "organizationId": "ID de l'organisation",
        "UUID": "UUID",
        "certificate": "Certificat",
        "createdAt": "Créé le",
        "updatedAt": "Mis à jour le",
        "certificateExpiry": "Expire le",
        "certificateVerificationMethod": "Méthode de vérification",
        "certificateDidJson": "DID JSON",
        "status": "Statut",
        "certificateDownloadSuccess": "Certificat téléchargé avec succès",
        "deleteCertificate": {
          "heading": "Supprimer la confirmation",
          "question": "Êtes-vous sûr de vouloir supprimer le certificat ?",
          "deleteSuccess": "Certificat supprimé avec succès"
        }
      }
    }
  },
  "build": {
    "ownedDataspaces": "Mes espaces de données",
    "checkConsent": "Je consentement à mes données de contact fournies à une équipe de vente T-Systems et à être contacté.",
    "welcomeOwnedDataspace": "Bienvenue dans «Mes Dataspaces»",
    "resendInvitation": "Renvoyer",
    "resendInvitationInfo": "Vous pouvez envoyer la notification dès que 24 heures se sont écoulées depuis le dernier e-mail d’invitation.",
    "requestSuccessTitle": "Demande réussie!",
    "requestSuccessBody": "Votre demande a bien été envoyée... Vous recevrez une réponse dans les jours ouvrables",
    "requestAuthorisation": "Veuillez contacter dih.support{'@'}telekom.com si vous souhaitez augmenter l'autorisation nécessaire.",
    "inviteParticipant": {
      "buttonLabel": "Inviter un participant",
      "successNotificationTitle": "Invitation réussie !",
      "successNotificationContent": "Votre invitation a été envoyée avec succès",
      "alreadySentNotificationTitle": "Une invitation a déjà été envoyée à cette adresse e-mail.",
      "alreadySentNotificationContent": "Veuillez attendre 24 heures avant d’envoyer à nouveau l’invitation.",
      "resendInviteNotificationTitle": "Ré-invitation réussie!",
      "resendInviteNotificationContent": "Votre réinvitation a été envoyée avec succès",
      "modal": {
        "title": "Inviter un participant",
        "informationTitle": "Information",
        "informationText": "L’organisation invitée peut échanger des données avec d’autres participants et publier de nouvelles ressources de données dans l’espace de données. De plus, l’organisation peut consommer des applications et des services qui font partie de votre espace de données.",
        "formTitle": "Veuillez saisir les coordonnées du nouveau participant",
        "organizationName": "Nom de l’organisation",
        "proceed": "Procéder",
        "cancel": "Annuler"
      },
      "withdrawInvitation": {
        "modal": {
          "title": "Retirer l'invitation",
          "informationText": "Êtes-vous sûr de vouloir retirer l'invitation ?",
          "successNotificationTitle": "Retrait réussi",
          "successNotificationBody": "Invitation retirée avec succès",
          "withdraw": "Retirer"
        }
      },
      "resendInvitation": {
        "modal": {
          "title": "Renvoyer l'invitation",
          "informationText": "Êtes-vous sûr de vouloir renvoyer cette invitation ?"
        }
      }
    },
    "editParticipant": {
      "modal": {
        "title": "Modifier le participant",
        "cancel": "Annuler",
        "save": "Sauvegarder",
        "roleSection": {
          "name": "Rôle",
          "helpText": "Quel rôle dois-je choisir ?",
          "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
          "ownerLabel": "Propriétaire de l'espace de données",
          "ownerTooltip": "Propriétaire de l'espace de données pouvant gérer les participants et les applications",
          "operatorLabel": "Opérateur de l'espace de données",
          "operatorTooltip": "Participant pouvant gérer l'outil de l'opérateur et intégrer des applications",
          "operatorCheckboxTooltip": "Vous êtes le propriétaire de l'espace de données. Par conséquent, vous ne pouvez pas désélectionner Opérateur.",
          "appProviderLabel": "Fournisseur d'applications",
          "appProviderTooltip": "Participant de l'espace de données pouvant intégrer des applications dans l'espace de données",
          "participantLabel": "Participant de l'espace de données",
          "participantTooltip": "Participant pouvant agir en tant que fournisseur et consommateur de données",
          "participantCheckboxTooltip": "DLe participant Ataspace ne peut pas être désactivé. C’est le statut par défaut d’un utilisateur dans un espace de données."
        },
        "visibilitySection": {
          "name": "Visibilité",
          "helpText": "Quelle visibilité dois-je choisir ?",
          "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
          "anonymousLabel": "Anonyme",
          "anonymousLabelTitle": "Participant anonyme",
          "anonymousTooltip": "Participant qui est masqué des autres participants et qui n’est pas en mesure de voir les autres participants"
        }
      },
      "updateSuccessfulTitle": "Mise à jour réussie !",
      "updateSuccessfulBody": "De nouveaux rôles et une nouvelle visibilité ont été adoptés"
    },
    "applicationManagement": {
      "buttonLabel": "Enregistrer la demande",
      "registerForm": {
        "pageTitle": "Enregistrement de l’application",
        "step1Name": "Détails de l’application",
        "step2Name": "Accès à l’application",
        "displayName": "Nom d’affichage",
        "providedBy": "Fourni par",
        "providedByPlaceholder": "Nom de l’organisation",
        "description": "Description",
        "descriptionPlaceholder": "Texte de description",
        "link": "Link",
        "linkPlaceholder": "https://www.application-link-example.org/",
        "errorUploadingFile": "Erreur lors du téléchargement du fichier. Veuillez réessayer.",
        "appImage": "Image de l'application (JPG ou PNG, limitée à 2 Mo)*",
        "appImagePlaceholder": "Glissez-déposez des fichiers ici ou cliquez pour en sélectionner",
        "appImagePlaceholder2": "ou parcourez les fichiers sur votre ordinateur",
        "category": "Catégorie",
        "categoryPlaceholder": "Entrez la catégorie",
        "usecases": "Cas d'utilisation",
        "usecasesPlaceholder": "Entrez les cas d'utilisation",
        "agreementCheckboxLabel": "Par la présente, je consens à être entièrement responsable de l’application que j’enregistre et à ce qu’il ne s’agisse pas d’un logiciel malveillant d’aucune sorte. De plus, j’ai veillé à ce qu’il n’y ait pas de violation de licence. Je comprends que je suis entièrement responsable de la gestion de l’accès à l’application et que T-Systems International GmbH n’assume aucune responsabilité à cet égard. T-System International GmbH n’est pas responsable de l’application et de ses conséquences possibles de quelque manière que ce soit."
      },
      "deleteApplication": {
        "modal": {
          "title": "Supprimer l’application",
          "informationText1": "Veuillez reconfirmer que vous êtes sûr de vouloir supprimer ce lien de candidature de votre espace de données. Cette candidature ne sera plus disponible pour aucun participant de votre espace de données.",
          "informationText2": "Veuillez noter que l'application proprement dite ne sera pas affectée!",
          "successNotificationTitle": "Suppression réussie",
          "successNotificationBody": "Application supprimée avec succès",
          "cancel": "Annuler",
          "delete": "SupprimerTranslation"
        }
      },
      "editForm": {
        "pageTitle": "Enregistrement de l’application",
        "step1Name": "Détails de l’application",
        "step2Name": "Accès à l’application",
        "displayName": "Nom d’affichage",
        "providedBy": "Fourni par",
        "providedByPlaceholder": "Nom de l’organisation",
        "description": "Description",
        "descriptionPlaceholder": "Texte de description",
        "link": "Link",
        "successNotificationTitle": "Édition réussie",
        "successNotificationBody": "La demande a été éditée avec succès",
        "linkPlaceholder": "https://www.application-link-example.org/",
        "currentImage": "Image actuelle",
        "agreementCheckboxLabel": "Par la présente, je consens à être entièrement responsable de l’application que j’enregistre et à ce qu’il ne s’agisse pas d’un logiciel malveillant d’aucune sorte. De plus, j’ai veillé à ce qu’il n’y ait pas de violation de licence. Je comprends que je suis entièrement responsable de la gestion de l’accès à l’application et que T-Systems International GmbH n’assume aucune responsabilité à cet égard. T-System International GmbH n’est pas responsable de l’application et de ses conséquences possibles de quelque manière que ce soit.",
        "cancel": "Annuler",
        "save": "Enregistrer les modifications"
      }
    },
    "networkManagement": {
      "buttonLabel": "Ajouter une nouvelle adresse IP",
      "pageTitle": "Gestion du réseau",
      "ipAddressLabel": "Adresse IP",
      "lastUpdatedOn": "Dernière mise à jour le",
      "ipHint": "La demande de mise à jour de l'adresse IP a été reçue et sera traitée sous peu.",
      "ipRemove": "Êtes-vous sûr de vouloir supprimer cette adresse IP ?",
      "ipRequired": "L'adresse IP est requise",
      "ipInvalid": "Entrez une adresse IP valide",
      "ipEnter": "Entrez l'adresse IP que vous souhaitez autoriser pour accéder à l'espace de données."
    },
    "invite": {
      "inviteLabel": "Inviter un participant"
    },
    "allocateConnectors": {
      "pageTitle": "Allocation de connecteur",
      "allocateConnectorLabel": "Allouer des connecteurs",
      "topUpConnectorsButtonLabel": "Connecteurs de recharge",
      "topUpConnectorTitle": "Votre demande a été soumise avec succès.",
      "topUpConnectorBody": "Notre équipe d’assistance vous contactera dans les plus brefs délais pour discuter de plus amples détails.",
      "generalTooltipMessage": "Veuillez contacter le support DIH (dih.support{'@'}telekom.com) pour allouer de nouveaux connecteurs aux participants existants ou pour inviter un nouveau participant dans l’espace de données.",
      "tooltipMessage": "Vous avez déjà atteint le nombre maximum de connecteurs disponibles selon votre contrat. Veuillez contacter dih.support{'@'}telekom.com si vous souhaitez augmenter le quota ou modifier le contrat.",
      "allocationForm": {
        "step1Name": "Organisation",
        "step2Name": "Connecteurs",
        "organizationNameDescription": "Sélectionnez l’entreprise à laquelle les nouveaux connecteurs doivent être attribués",
        "organizationNameLabel": "Nom de l’organisation",
        "organizationPlaceholder": "Choisir l’organisation",
        "inviteParticipantDescription": "Ou cliquez sur le bouton Inviter un participant pour inviter une nouvelle entreprise à collaborer, sur l’espace de données",
        "inviteParticipantButton": "Inviter un participant",
        "numberOfConnectorsDescription": "Choisissez le nombre de connexions",
        "numberOfConnectorsLabel": "Nombre de connecteurs",
        "numberOfConnectorsPlaceholder": "Compter",
        "progressBarDescription": "Quota de connecteur",
        "progressBarInfo": "{numberOfConnectors} connecteurs disponibles",
        "allocateButtonLabel": "Allouer",
        "cancelButtonLabel": "Annuler",
        "noConnectorRemaining": "Tous les connecteurs sont utilisés. Veuillez cliquer sur \"Connecteurs de recharge\" pour discuter de l’extension des connecteurs avec notre équipe."
      },
      "successRequestTest": "Demande réussie",
      "successRequestBody": "L’allocation de connecteur a été lancée avec succès",
      "decisionModal": {
        "title": "Vous avez été invité(e) à rejoindre {dataspaceName}",
        "accept": "Accepter",
        "decline": "Décliner",
        "acceptSuccessNotificationTitle": "Acceptation réussie !",
        "acceptSuccessNotificationBody": "Vous avez accepté avec succès l’invitation à rejoindre {dataspaceName}.",
        "declineSuccessNotificationTitle": "Invitation refusée !",
        "declineSuccessNotificationBody": "Vous avez décliné l’invitation à rejoindre {dataspaceName}."
      }
    },
    "request": {
      "requestTitle": "Faites la prochaine étape sur le parcours de partage de données et créez votre propre Dataspace!",
      "requestDescription1": "Vous souhaitez non seulement partager vos propres données, mais aussi permettre à vos partenaires commerciaux de partager les données les uns avec les autres? Ensuite, vous devriez envisager de créer une salle de données, qui est une communauté de confiance pour partager ou monétiser les données.",
      "requestDescription2": "T-Systems configurera et exploitera votre Dataspace sur notre infrastructure fiable.",
      "requestDescription3": "Nous proposons également des configurations de test à faible seuil pour vos premières expériences de Dataspace („LivingLab“).",
      "request": "Demande",
      "sendAnotherRequest": "Envoyer une autre demande",
      "lastRequest": "Votre dernière demande a été envoyée",
      "back": "Retour",
      "sendRequest": "Envoyer une demande",
      "requestedTextPlaceholder": "Vous recherchez quelque chose de spécifique ou de consultation générale? Une expérience antérieure avec DataSpaces? Intéressé par une configuration de test?",
      "visitorAnalyticsPro": {
        "title": "Demander Visitor Analytics PRO par Motion Data",
        "placeholder": "Êtes-vous à la recherche d’un ou de plusieurs produits spécifiques ou d’un conseil général pour vos besoins en matière de données ? Avez-vous déjà eu de l’expérience avec les produits Motion Data ? Intéressé par une démonstration ?"
      }
    },
    "create": {
      "createTitle": "Créez votre propre Dataspace",
      "createDesc": "Vous pouvez envoyer une demande à notre équipe d'experts et nous vous répondrons.",
      "tellUsMore": "Pouvez-vous nous en dire plus sur votre demande?"
    },
    "details": {
      "approve": "Approuver",
      "decline": "Décliner",
      "approval": "Approbation",
      "requesterNotes": "Notes du demandeur",
      "adminNotes": "Notes de l’administrateur",
      "decisionTakenTooltip": "L’acceptation ou le refus a déjà eu lieu. La mise à disposition des connecteurs est en cours de préparation. Vous serez informé dès que celles-ci auront été remplies.",
      "decisionInputPlaceholder": "Notes d’approbation ou de refus ...",
      "activeParticipants": "Participants actifs",
      "incomingRequests": "Demandes entrantes",
      "invitations": "Invitations",
      "manage": "Gérer",
      "enter": "Entrer",
      "providedBy": "Fourni par",
      "registered": "Inscrit",
      "operatorToolkit": "Boîte à outils de l'opérateur",
      "noOperatorToolkit": "Vous n’avez aucun outil activé dans la boîte à outils opérateur.",
      "errorOperatorToolkit": "Erreur lors de la récupération des détails de la boîte à outils opérateur",
      "dataspaceDetails": "Détails du Dataspace",
      "contactDetails": "Coordonnées",
      "visibilityTitle": "Masquer votre espace de données de la liste des espaces de données de navigation",
      "manageParticipants": "Gérer les participants",
      "applicationManagement": "Gestion des applications",
      "networkManagement": "Gestion du réseau",
      "noApplications": {
        "title": "Vous n’avez pas encore de candidature",
        "actionButtonText": "Enregistrer la demande"
      },
      "contactUs": "Si vous souhaitez mettre à jour des informations, veuillez nous contacter directement",
      "noData": "Vous n'avez pas encore de données",
      "basic": "Basique",
      "companyName": "Nom de l'entreprise",
      "participantName": "Nom du participant",
      "participationMode": "Mode de participation",
      "connectorName": "Nom du connecteur",
      "connectorVariant": "Variante de connecteur",
      "contact": "Contact",
      "address": "Adresse",
      "street": "Rue",
      "number": "Nombre",
      "postalCode": "Code postal",
      "city": "Ville",
      "country": "Pays",
      "contactPerson": "Personne de contact",
      "phoneNo": "Phone number",
      "email": "E-mail",
      "dateOfJoining": "Date d'adhésion",
      "dateOfInvitation": "Date",
      "operator": "Opérateur",
      "dateOfRequest": "Date de la demande",
      "url": "URL",
      "status": "Statut",
      "bpn": "Numéro de partenaire commercial",
      "name": "Nom",
      "description": "Description",
      "website": "Site web",
      "dataspaceId": "ID de Dataspace",
      "password": "Mot de passe",
      "digitalId": "Cet espace de données est compatible avec Digital.ID",
      "disableDigitalId": "Digital.ID n'est pas activé pour cette Dataspace",
      "company": "Compagnie | Entreprises",
      "connector": "Connecteur | Connecteurs",
      "application": "Application | Applications",
      "dataoffer": "Offre de données | Offres de données",
      "visibility": "Votre Dataspace est maintenant {Access}",
      "discoverable": "Découvrable",
      "private": "Privé",
      "statusTooltip": {
        "invited": "L'invitation à rejoindre l'espace de données a été envoyée",
        "inprogress": "L'invité a soumis le formulaire d'intégration",
        "expired": "L'invitation a expiré en raison de 14 jours d'inactivité",
        "withdrawn": "L'invitation a été retirée",
        "rejected": "La demande d'intégration a été rejetée. Veuillez contacter dih.support{'@'}telekom.com pour plus de détails",
        "active": "Le participant a été intégré avec succès",
        "failed": "Échoué"
      },
      "deleteParticipant": {
        "modal": {
          "title": "Supprimer le participant",
          "informationText": "Le connecteur appartenant au participant sera dédéployé lors de la confirmation. Cette action ne peut pas être annulée.",
          "successNotificationTitle": "Suppression Demandée",
          "successNotificationBody": "La suppression d'un participant a été demandée",
          "cancel": "Annuler",
          "delete": "Supprimer"
        }
      },
      "services": {
        "applicationOrchestration": "Orchestration des applications",
        "applicationOrchestrationDesc": "Déployez et gérez vos applications d'entreprise",
        "identityAccessManagement": "Gestion de l'identité et de l'accès",
        "identityAccessManagementDesc": "Gérez vos utilisateurs et leur accès aux ressources",
        "continuousDelivery": "Livraison continue",
        "continuousDeliveryDesc": "Adoptez les meilleures pratiques de déploiement et d'opérations",
        "secretCredentialManagement": "Gestion secrète et des diplômes",
        "secretCredentialManagementDesc": "Sécuriser, stocker et contrôler l'accès aux jetons, aux mots de passe et aux certificats",
        "monitoring": "Surveillance",
        "monitoringDesc": "Interroger, visualiser, être alerté et comprendre vos mesures et vos KPI",
        "connectorTest": "Vérification de la santé du connecteur",
        "connectorTestDesc": "Service pour exécuter une vérification de la santé des connecteurs.",
        "catenaXSandbox": "Catena-X Sandbox",
        "catenaXSandboxDesc": "Démarrez votre bac à sable Catena-X dans votre LivingLab pour développer et tester vos nouvelles applications métier dans l’environnement Catena-X."
      }
    },
    "connectorHealthCheck": {
      "title": "Vérification de la santé du connecteur",
      "viewResults": "Voir les résultats",
      "close": "Fermer",
      "description": "Sélectionnez un ou plusieurs connecteurs sur lesquels vous souhaitez effectuer une vérification de la santé. Les opérations de l'espace de données standard ne sont pas affectées par la vérification de la santé.",
      "connectors": "Connecteurs",
      "placeholder": "Sélectionnez des connecteurs",
      "searchInputLabel": "Rechercher des connecteurs...",
      "banner": "La vérification de la santé peut prendre quelques minutes. Vous serez informé dès que les résultats seront disponibles.",
      "action": "Initier",
      "history": {
        "connectorName": "Nom du connecteur",
        "initiated": "Initié",
        "completed": "Terminé",
        "result": "Résultat",
        "successMessage": "{connectorName} fonctionne comme prévu",
        "unsuccessfulMessage": "{connectorName} ne fonctionne pas comme prévu. Veuillez contacter "
      },
      "successNotificationTitle": "Vérification de l'état du connecteur lancée.",
      "successNotificationContent": "Vous serez informé lorsque le résultat sera disponible.",
      "noTest": "Vous n'avez pas encore de tests",
      "initiateTest": "Lancer le test"
    },
    "specifications": {
      "table": {
        "attribute": "Attribut",
        "value": "Valeur",
        "cloudProvider": "Fournisseur de cloud",
        "contractStart": "Début du contrat",
        "contractDuration": "Durée du contrat",
        "cpu": "CPU",
        "ram": "RAM",
        "storage": "Stockage",
        "maximumConnectorsBookable": "Connecteurs maximums réservables",
        "subscribedConnectors": "Connecteurs souscrits"
      },
      "dataspaceSpecifications": "Spécifications de l'espace de données",
      "livinglabCore": "Noyau de LivingLab",
      "livinglabAppLayer": "Couche d'application de LivingLab"
    },
    "connectorManagement": {
      "connectorManagement": "Connecteurs",
      "connectorName": "Nom du connecteur",
      "connectorType": "Type de connecteur",
      "targetParticipant": "Participant cible",
      "connectorOwner": "Propietario del conector",
      "url": "URL",
      "status": "Statut",
      "connectorUrl": "URL du connecteur",
      "connectorUiUrl": "URL de l'interface utilisateur du connecteur",
      "connectorRegistration": "Enregistrement du connecteur",
      "connectorDeployment": "Déploiement du connecteur",
      "technicalUser": "Utilisateur technique",
      "selfDescRegistration": "Auto-description enregistrement",
      "connectorDeleteTitle": "Êtes-vous sûr de vouloir supprimer le connecteur ?",
      "connectorDeleteDescription": "Remarque : Cette action ne supprime ni n'arrête l'instance de connecteur réelle en cours d'exécution dans votre infrastructure. Une fois supprimé, ce connecteur n'apparaîtra plus dans le portail DIH et ne sera plus disponible pour les transactions de données au sein de cet espace de données jusqu'à ce qu'il soit réenregistré.",
      "deleteSuccessMessage": "Connecteur supprimé avec succès",
      "saveSuccessMessage": "Les détails du connecteur ont été mis à jour avec succès",
      "registerConnector": "Enregistrer votre propre connecteur",
      "howToConfigure": "Comment configurer votre connecteur",
      "howToDescription": "Les informations ci-dessous fournissent les valeurs de configuration nécessaires pour enregistrer puis déployer votre connecteur externe. Ces paramètres permettent à votre connecteur de s'authentifier correctement et d'interagir avec les services Dataspace.",
      "howToDescription1": "Avant le déploiement, votre connecteur doit être enregistré dans l'espace de données. Ce flux couvre l'étape d'enregistrement. Les champs URL que vous saisirez dans les prochaines étapes pourront être modifiés ultérieurement, vous pouvez donc continuer même si certains points de terminaison ne sont pas encore définitifs.",
      "supportedEDCVersions": "Versions EDC prises en charge :",
      "howToInfo": {
        "info1": "iatp.sts.oauth.client.id : ID client de l’utilisateur technique pour ce connecteur spécifique.",
        "info2": "iatp.sts.oauth.client.secret : Secret de l’utilisateur technique pour ce connecteur spécifique.",
        "info3": "Les deux valeurs mentionnées ci-dessus seront disponibles une fois l’enregistrement du connecteur terminé. Vous pouvez déployer le connecteur après avoir terminé le processus d’enregistrement."
      },
      "connectorRegistationTitle": "Détails d’enregistrement du connecteur",
      "location": "Emplacement*",
      "locationError": "La localisation est requise",
      "connectorRegistrationProgress": "Enregistrement du connecteur en cours",
      "connectorCatalogEndpoint": "Point de terminaison du catalogue des connecteurs*",
      "connectorUIEndpoint": "Point de terminaison UI du connecteur (optionnel)",
      "connectorRegistrationInfo": "Le statut d’enregistrement du connecteur peut être vérifié dans la section de gestion des connecteurs du dataspace.",
      "viewConfiguration": "Voir la configuration",
      "name": "Nom",
      "value": "valeur",
      "stepToDeployConnector": "Étapes pour déployer un connecteur:",
      "deploymentGuide": "Guide de déploiement du connecteur",
      "clientIdDummyValue": "ID client de votre utilisateur technique pour le connecteur",
      "secreteDummyValue": "Secret de l’utilisateur technique pour le connecteur",
      "failedConnectorDeploymentTooltip": "Connector ist derzeit nicht verfügbar. Einsatz steht aus."
    }
  },
  "profile": {
    "profile": "Profil",
    "userProfile": "Profil de l'utilisateur",
    "personalInfo": "Informations personnelles",
    "personalDetails": "Détails personnels et paramètres",
    "changeDetailsMessage": "Si vous souhaitez modifier des détails, veuillez contacter",
    "changeDetailsLinkText": "Assistance",
    "memberships": "Adhésion",
    "security": "Sécurité",
    "setUp2FA": "Configurer 2FA",
    "accountInformation": "Information sur le compte",
    "deleteAccount": "Supprimer le compte utilisateur",
    "deleteAccountDescription": "Avec cette action, tous les fichiers de données et de données associés à votre compte personnel seront supprimés.",
    "accountSecurity": "Sécurité du compte",
    "yourInfomration": "Vos informations",
    "fullName": "Nom et prénom",
    "contact": "Contact",
    "language": "Langue",
    "changePassword": "Changer le mot de passe",
    "please": "Veuillez",
    "contactSupport": "Contactez le support",
    "toDownload": "Pour télécharger ces informations",
    "toDelete": "Pour supprimer votre profil",
    "roles": "Les rôles",
    "memberSince": "Membre depuis",
    "orgLegalName": "Nom légal de l'organisation",
    "bpnNumber": "Numéro de partenaire commercial (BPN)",
    "commRegNumber": "Numéro de registre commercial",
    "vatIdNumber": "numéro de TVA",
    "hqAddress": "Adresse du siège",
    "legalIdentifier": "Identifiant légal",
    "additionalAttributes": "Attributs supplémentaires",
    "languageSwitcherMessage": "Une partie de cette page a été traduite automatiquement ou par IA. Vous pensez que cela peut être amélioré ? Faites-le nous savoir à dih.support{'@'}telekom.com."
  },
  "plansBenefits": {
    "communicationIntegrity": "Intégrité de la communication",
    "protectedConnection": "Connexion protégée",
    "mutualAuth": "Authentification mutuelle",
    "stateArtOfCrypto": "Cryptographie de pointe",
    "remoteAttestation": "Attestation à distance",
    "platforInt": "Intégrité de la plate-forme",
    "configureAndApp": "Configuration et intégration des applications",
    "dataUsageControl": "Contrôle d'utilisation des données",
    "definitionOfUsagePolicy": "Définition de la politique d'utilisation",
    "from": "depuis",
    "month": "mois",
    "connect": "Connecter"
  },
  "cookieSettings": {
    "collapsedTitle": "Paramètres de confidentialité",
    "collapsedText": "Ce site Web utilise des cookies et des technologies similaires. Ce sont de petits fichiers texte qui sont stockés et lus sur votre ordinateur. En cliquant sur '{0}', vous acceptez le traitement, la création de profils utilisateur individuels sur les sites Web et les partenaires, ainsi que la transmission de vos données à des tiers, dont certains traitent vos données dans des pays en dehors de l'Union européenne (RGPD Art. 49). Les détails se trouvent dans la section 2 de la {1}. Les données sont utilisées à des fins d'analyse, de reciblage et d'affichage de contenu et de publicité personnalisés sur les sites Telekom et les sites tiers. De plus amples informations, y compris des informations sur le traitement des données par des fournisseurs tiers et la possibilité de révocation, se trouvent dans les paramètres et dans notre politique de confidentialité. Ici, vous pouvez {2} uniquement avec les outils nécessaires.",
    "extendedTitle": "Paramètres de confidentialité",
    "extendedText": "Afin de vous offrir une expérience optimale sur notre site Web, nous utilisons des cookies. Ceux-ci incluent des cookies pour le fonctionnement et l'optimisation du site, ainsi que pour des services tels que le chat texte ou vidéo et la publicité basée sur votre comportement en ligne. Cela nous permet, par exemple, de détecter si vous visitez nos pages à plusieurs reprises à partir du même appareil. Nous aimerions vous donner le choix des cookies que vous autorisez :",
    "onlyRequired": "Seulement requis",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "informations de confidentialité",
    "policyLinkText": "Informations de confidentialité",
    "rejectLinkText": "continuer",
    "acceptButton": "Accepter tout",
    "saveButton": "Enregistrer les paramètres",
    "settingsButton": "Modifier les paramètres",
    "showMore": "Montrer plus",
    "showLess": "Montrer moins",
    "categoryTitleEssential": "Cookies requis",
    "categoryTitleAnalytics": "Cookies analytiques",
    "categoryTitleMarketing": "Cookies marketing",
    "categoryTitleThirdParty": "Services d'autres sociétés (fournisseurs de tiers indépendants)",
    "categoryTextEssential": "Ces cookies sont nécessaires pour vous permettre de naviguer sur les sites Web et d'utiliser des fonctions essentielles. Ils prennent en charge des fonctions de base, telles que le traitement des commandes dans la boutique en ligne et l'accès aux zones sécurisées du site Web. Ils servent également à effectuer une analyse anonyme des modèles d'utilisation, que nous utilisons pour développer et améliorer continuellement nos pages Web.",
    "categoryTextAnalytics": "Ces cookies nous aident à améliorer notre compréhension du comportement des utilisateurs. Les cookies d'analyse permettent la compilation de données d'utilisation et d'identification par le fournisseur d'origine ou par des fournisseurs tiers en profils d'utilisation pseudonymes. Nous utilisons des cookies d'analyse, par exemple, pour déterminer le nombre de visiteurs individuels sur une page Web ou un service, pour collecter des données statistiques sur les performances de nos produits et pour analyser les modèles d'utilisation et les interactions des visiteurs sur la base d'informations anonymes et pseudonymes. Ces informations ne peuvent pas être reliées à une personne.",
    "categoryTextMarketing": "Ces cookies et technologies similaires sont utilisés pour permettre l'affichage de contenu marketing personnalisé et donc pertinent. Les cookies marketing sont utilisés pour afficher un contenu publicitaire intéressant et mesurer l'efficacité de nos campagnes. Cela se produit non seulement sur les sites Web Telekom, mais aussi sur d'autres sites de partenaires publicitaires (fournisseurs tiers). Ceci est également appelé reciblage. Il est utilisé pour créer du contenu pseudonyme ou des profils publicitaires, pour placer la publicité pertinente sur d'autres sites Web et pour dériver des informations sur les groupes cibles qui ont visionné les annonces et le contenu. Ces informations ne peuvent pas être retracées à une personne. Les outils de marketing et de reciblage nous aident à vous servir de contenu publicitaire potentiellement pertinent pour vous. En supprimant les cookies marketing, vous verrez toujours la même quantité de publicité, mais cela peut être moins pertinent pour vous.",
    "categoryTextThirdParty": "Les sites Internet de Telekom comportent des liens vers des fournisseurs de services tiers, qui proposent leurs services sous leur propre responsabilité. Lorsque vous consultez un site Internet de Telekom, des cookies ou des technologies similaires enregistrent des données et les transmettent à des tiers, en partie pour répondre à des objectifs propres à Telekom. L'étendue, l'objectif et la base juridique du traitement ultérieur effectué à des fins propres à la tierce partie sont indiqués dans les informations sur la confidentialité des données de ladite tierce partie. Des informations relatives aux fournisseurs tiers indépendants sont disponibles dans les informations sur la confidentialité des données."
  },
  "consultation": {
    "createDescription": "Vous pouvez envoyer une demande à notre équipe d'experts et nous vous répondrons.",
    "tellUsMore": "Pouvez-vous nous en dire plus sur votre demande ?",
    "checkConsent": "J'accepte que mes coordonnées soient fournies à une équipe commerciale de T-Systems et que je sois contacté.",
    "back": "Dos",
    "sendRequest": "Envoyer une demande",
    "successMsgtitle": "Demande réussie !",
    "successMsgBody": "Votre demande a bien été envoyée... vous recevrez une réponse dans quelques jours ouvrés"
  },
  "notifications": {
    "notifications": "Notifications",
    "inbox": "Boîte de réception",
    "clearAll": "Tout effacer",
    "blankState": {
      "heading": "Aucune notification pour le moment",
      "description": "Lorsque vous recevrez des notifications, ils apparaîtront ici",
      "actionButtonText": "Rafraîchir"
    },
    "actionMessage": {
      "seeRequest": "Voir la demande",
      "checkResult": "Vérifier le résultat ",
      "here": "ici"
    },
    "goToMyAccount": "Veuillez consulter les informations sur votre nouveau rôle sous {myAccountLink}."
  },
  "statusTile": {
    "noMembership": {
      "title": "Vous n'avez pas encore d'adhésion",
      "subTitle": "Parcourir les données pour rejoindre un",
      "getConnected": "Soyez connectés"
    }
  },
  "settings": {
    "organization": {
      "pageTitle": "Mon organisation",
      "orgDetails": "Détails de l'organisation",
      "teamMembers": "Membres de l'équipe",
      "groups": "Groupes",
      "groupsOverview": "Aperçu des groupes",
      "technicalUsers": "Utilisateurs techniques",
      "singleSignOn": "Authentification unique",
      "mapGroupClaims": "Revendications du groupe de cartes"
    },
    "teamMembers": {
      "title": "Gestion des utilisateurs",
      "description": "Cette section aide à gérer les utilisateurs de votre organisation"
    },
    "groups": {
      "title": "Gestion du groupe",
      "description": "Les groupes représentent des départements au sein de votre organisation. Un utilisateur dans un groupe est toujours aussi membre de l'organisation principale.",
      "createGroup": "Créer un groupe",
      "groupName": "Nom du groupe",
      "groupDesc": "Description du groupe",
      "groupCreateNote": "Les membres peuvent être affectés à ce groupe après leur création. Seuls les membres existants de l’organisation peuvent être ajoutés.",
      "membersTitle": "Membres",
      "members": "Membre(s)",
      "createdBy": "Créé par",
      "createdOn": "Créé sur",
      "contactPerson": "Personne de contact",
      "actions": "Actions",
      "groupMembers": "Membres du groupe",
      "groupDetails": "Détails du groupe",
      "groupMembersDescription": "Attribuer les membres existants de l'organisation à ce groupe",
      "disableAddMembers": "L’appartenance au groupe est gérée via des claims SSO. Utilisez votre fournisseur d’identité pour gérer l’accès au groupe.",
      "addMembers": "Ajouter des membres",
      "fullName": "Nom complet",
      "addedToGroup": "Ajouté au groupe",
      "addMembersTo": "Ajouter des membres à “{name}”",
      "addToGroup": "Ajouter au groupe",
      "addMemberDescription": "Choisissez parmi les membres de votre organisation. Les membres sélectionnés resteront également membres de l'organisation principale.",
      "membersSelected": "Membre(s) sélectionné(s)",
      "editSuccess": "Détails du groupe édités avec succès",
      "addMemberSuccess": "Utilisateur(s) sélectionné(s) ajouté(s) au groupe avec succès",
      "duplicateGroupNameError": "Un groupe portant ce nom existe déjà. Veuillez choisir un autre nom."
    },
    "inviteUser": {
      "inviteUsers": "Inviter les utilisateurs",
      "newEmailAddress": "Adresse e-mail des nouveaux membres de l'équipe",
      "chooseRole": "Choisir le rôle",
      "whichRoleToSelect": "Quel rôle dois-je sélectionner?",
      "roleNote": "Un rôle sélectionné sera donné à tous les utilisateurs invités",
      "roleError": "Veuillez sélectionner au moins 1 rôle parmi les options disponibles",
      "roleErrorShort": "Veuillez sélectionner au moins 1 rôle",
      "cancel": "Annuler",
      "sendInvite": "Envoyer l'invitation",
      "fullName": "Nom et prénom",
      "status": "Statut",
      "role": "Rôle",
      "memberSince": "Membre depuis"
    },
    "inviteSuccess": {
      "title": "Résumé de l'invitation",
      "totalInvitation": "{count} invitation a été envoyé | {count} Les invitations ont été envoyées",
      "description": "{count} invitation n’a pas été envoyée car l’adresse e-mail existe déjà dans le Data Intelligence Hub | {count} invitations n’ont pas été envoyées car les adresses e-mail existent déjà dans le Data Intelligence Hub",
      "actionContinue": "Continuer"
    },
    "roleChange": {
      "areYouSure": "Êtes-vous sûr de vouloir faire ces changements de rôle ?",
      "yeahSure": "Oui, j’en suis sûr"
    },
    "technicalUser": {
      "title": "Identifiants techniques de l'utilisateur",
      "createdAt": "créé à",
      "clientId": "ID client",
      "clientSecret": "Client Secret",
      "sendCredEmailBtn": "Envoyer les identifiants à mon e-mail",
      "sendCredEmailDescription": "Un e-mail contenant vos identifiants sera envoyé à votre adresse e-mail. Veuillez vérifier votre boîte mail dans quelques minutes.",
      "use": "utiliser le",
      "clipboardText": "icône pour copier l'ID du client dans le clipboard.",
      "successText": "Un e-mail contenant vos identifiants a été envoyé avec succès à votre adresse e-mail",
      "actions": "Actions"
    },
    "sso": {
      "description": "Connectez le fournisseur d'identité de votre organisation afin d'activer la connexion basée sur le SSO.",
      "microsoftEntraId": "Microsoft EntraID",
      "tenantId": "ID du locataire :",
      "clientId": "ID client :",
      "redirectURI": "URI de redirection :",
      "groupClaimMappings": "Mappages des claims de groupe",
      "autoAssign": "Attribuer automatiquement les utilisateurs aux groupes en fonction des claims présents dans le jeton identity provider.",
      "setupGroupClaims": "Configurer les claims de groupe",
      "noIdentityProviderConfigured": "Aucun fournisseur d'identité configuré",
      "contact": "Veuillez contacter dih.support{'@'}telekom.com pour configurer un fournisseur d'identité externe.",
      "claimName": "Nom de revendication",
      "mappings": "Applications",
      "idpClaimValue": "Valeur de la réclamation Identity Provider",
      "dihGroups": "Groupes",
      "groupMappingDisclaimer": "Tous les utilisateurs mappés reçoivent par défaut le rôle Business-User.",
      "groupClaimNameDescription": "Cartographiez les valeurs des groupes du jeton identity provider vers les groupes dans le portail.",
      "claimNameDisclaimer": "La clé dans le jeton identity provider qui contient les valeurs du groupe.",
      "claimNameLabel": "Les groupes revendiquent le nom dans le token *",
      "noMappingHeading": "Aucune correspondance encore définie",
      "noMappingSubheading": "Ajouter une correspondance pour assigner automatiquement les utilisateurs aux groupes.",
      "addMapping": "Ajouter la cartographie",
      "businessUserDisclaimer": "Tous les utilisateurs mappés sont assignés comme Business-User par défaut.",
      "businessUserDisclaimer2": "L'attribution des rôles est gérée séparément.",
      "reviewChanges": "Réviser les changements",
      "confirmSave": "Confirmer & Sauvegarder",
      "confirmModalDisclaimer1": "Les modifications prennent effet à la prochaine connexion utilisateur après la sauvegarde.",
      "confirmModalDisclaimer2": "Les utilisateurs actuellement assignés ne seront supprimés qu'à leur prochaine connexion.",
      "confirmBeforeSaving": "Confirmez les changements de cartographie suivants avant de sauvegarder."
    }
  },
  "completeInviteProfile": {
    "title": "Complétez votre compte",
    "description": "Vous avez été invité à Telekom Data Intelligence Hub. Pour compléter votre compte, veuillez remplir les informations requises.",
    "firstName": "Prénom",
    "firstNamePlaceholder": "Entrez votre prénom",
    "lastName": "Nom de famille",
    "lastNamePlaceholder": "Entrez votre nom de famille",
    "email": "E-mail",
    "emailPlaceholder": "Entrer le courrier électronique",
    "organisation": "Organisation",
    "organisationPlaceholder": "Entrez votre organisation",
    "enterPassword": "Entrer le mot de passe",
    "dataPrivacyCheck": "J'approuve que mes données personnelles sont stockées et traitées en fonction des objectifs indiqués dans le {dataAndPrivacyStatement}. *",
    "termsAndConditionsCheck": "Je confirme que j'ai lu et accepte les {termsandcondition} de Data Intelligence Hub.",
    "termsandcondition": "termes et conditions",
    "dataAndPrivacyStatement": "Déclaration de confidentialité des données",
    "cancel": "Annuler",
    "submit": "Soumettre",
    "success": {
      "title": "Votre compte est terminé",
      "description": "Vous serez dirigé vers la page de connexion",
      "actionContinue": "Continuer"
    }
  },
  "workbench": {
    "incomingDataAgreements": {
      "title": "Accords de données entrantes",
      "addedOn": "Ajouté sur",
      "expiresOn": "Expire le",
      "providedBy": "Fourni par",
      "dateAddedOn": "Date ajoutée",
      "noFilesAttached": "Aucun fichier n'est actuellement joint à cet accord de contrat",
      "noAgreementsMessage": "Vous n'avez aucun accord de données entrant",
      "receivingData": "Réception des données",
      "dataReceived": "Téléchargé",
      "error": "Une erreur s'est produite",
      "transferInitiated": "Transfert initié",
      "transferCompleted": "Transfert terminé !",
      "view": "Vue",
      "successDownload": "Ressource de données reçue avec succès",
      "errorDownload": "Le téléchargement de votre fichier pour {filename} a été interrompu avec une erreur, veuillez réessayer",
      "viewAggreement": "Voir l'accord",
      "agreeText": "En téléchargeant les fichiers, vous acceptez de vous conformer aux {contractTerms} du présent accord",
      "contractTerms": "Termes du contrat",
      "includedFile": "Fichier inclus",
      "createdOn": "Créé le",
      "fileType": "Type de fichier",
      "downloadError": "Échec de la récupération des accords de données entrants",
      "downloadSuccess": "Ressource de données reçue avec succès"
    },
    "contractDetails": {
      "termsAndPolicies": "Conditions d'utilisation et politiques",
      "offerBy": "Offre de",
      "addedOn": "Ajouté le",
      "expiresOn": "Expire le",
      "product": "Produit",
      "totalFiles": "Nombre total de dossiers",
      "description": "Description",
      "contractID": "N° de contrat",
      "contractTerms": "Conditions contractuelles",
      "files": "Fichiers",
      "parameters": "Paramètres",
      "referencePeriod": "Période de référence",
      "location": "Emplacement",
      "additionalLinks": "Liens supplémentaires",
      "dihMainPage": "Page principale de DIH",
      "download": "Télécharger",
      "search": "Rechercher",
      "title": "Titre",
      "createdOn": "Créé le",
      "kpiName": "KPI Nom",
      "fileType": "Type de fichier",
      "schema": "Schéma",
      "dashboard": "Tableau de bord",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "transfer": "Transfert",
      "downloadSelected": "Télécharger la sélection",
      "noTermsPolicy": "À l'heure actuelle, le fournisseur de données n'a spécifié aucune règle pour l'utilisation des données dans le cadre de ce contrat.",
      "youCan": "Vous pouvez",
      "youCant": "Tu peux pas",
      "youMust": "Il le faut",
      "respectContent": "Respecter le contenu du contrat de licence",
      "licenceAgreement": "Contrat de licence",
      "noAttachment": "Pas encore de pièces jointes",
      "termsandcondition": "Termes et conditions",
      "resellData": "Revendre les données",
      "youCanUseDataCommercial": "Nutzung der Daten für kommerzielle Zwecke",
      "youCanProcessData": "Traiter les données sur l'infrastructure en dehors de l'Union européenne",
      "youCanEmpty": "À l'heure actuelle, le fournisseur de données n'a spécifié aucune autorisation pour l'utilisation des données dans le cadre de ce contrat",
      "youCantEmpty": "À l'heure actuelle, le fournisseur de données n'a spécifié aucune interdiction d'utilisation des données dans le cadre de ce contrat",
      "youMustEmpty": "À l'heure actuelle, le fournisseur de données n'a spécifié aucune obligation pour l'utilisation des données dans le présent contrat"
    }
  },
  "messages": {
    "noDataAvailable": "Pas de données disponibles",
    "noMatchFound": "Pas de résultat trouvé",
    "maximumFileSize": "Taille maximale du fichier",
    "suitableFileFormats": "Formats de fichiers appropriés",
    "loading": "Chargement...",
    "dragDropText": "ou faites-le glisser et déposez-le ici"
  },
  "pageNotFound": {
    "title": "Oops ! Il semble que la page que vous cherchez n'existe pas encore.",
    "subtitle": "Découvrez nos autres ressources en attendant, qui pourraient vous être utiles !"
  },
  "unauthorized": {
    "pageNotAccessible": "Oups ! Il semble que la page que vous recherchez ne soit pas accessible avec vos autorisations.",
    "reachOutToAdministrator": "Veuillez contacter votre administrateur pour en savoir plus sur votre accès.",
    "checkOtherResources": "En attendant, consultez nos autres ressources."
  },
  "helpResources": {
    "needHelp": "Besoin d’aide pour trouver le bon plan, plus d’informations, des questions techniques ?",
    "FAQ": "Foire aux questions",
    "FAQDescription": "Trouvez plus de réponses courantes, de la facturation à la confidentialité",
    "browse": "Parcourir",
    "demos": "Démos",
    "demosDescription": "Trouvez des cas d'utilisation et des démos liés à votre secteur industriel",
    "glossary": "Glossaire",
    "glossaryDescription": "Trouvez les termes et définitions liés à la DIH, IDS, Catena-X, GAIA-X et plus encore."
  },
  "feedbackCard": {
    "giveUsFeedback": "Donnez-nous votre avis sur ce qui nous manque ?",
    "contactUs": "Contactez-nous"
  },
  "requestDataspaceJoin": {
    "title": "Demander la connexion à {dsName}",
    "basic": "Basique",
    "orgName": "Nom de l'organisation:",
    "contact": "Contact",
    "address": "Adresse:",
    "name": "Nom:",
    "email": "Messagerie électronique:",
    "joinReasonTitle": "S'il vous plaît, indiquez pourquoi vous voulez rejoindre l'espace de données ?",
    "joinConsent": "J'accepte de partager les détails ci-dessus avec le propriétaire de l'espace de données",
    "sendRequest": "Envoyer une demande"
  },
  "applications": {
    "myApplication": "Mes applications"
  },
  "externalConnection": {
    "title": "Gestionnaire de connexions externes",
    "noConnectionConfigureTitle": {
      "title": "Vous n'avez pas encore configuré de connexion",
      "newConnection": "Nouvelle connexion"
    },
    "request": {
      "connectionDetails": "Détails de connexion",
      "preferConnection": "Sélectionnez le mode de connexion au serveur préféré",
      "selectConnection": "Sélectionnez Connexion",
      "ageeTerms": "Par la présente, j’accepte et confirme que toutes mes informations et données personnelles mentionnées ci-dessus sont exactes",
      "grantConsent": "J’accorde mon consentement à Telekom Data Intelligence Hub pour le traitement et le stockage de ces données afin de faciliter les transferts d’actifs via la connexion fournie",
      "back": "Précédent",
      "addConnection": "Ajouter une connexion",
      "save": "Sauvegarder",
      "verifyConnectivity": "Vérifier la connectivité",
      "checkingConnection": "Vérification de la connexion",
      "connectionVerified": "Connexion vérifiée",
      "error": "Erreur",
      "requestSuccessTitle": "Ajouté avec succès !",
      "requestSuccessText": "Vous avez ajouté avec succès vos informations de connexion.",
      "requestUpdatedTitle": "Mise à jour réussie !",
      "requestUpdatedText": "Vous avez mis à jour avec succès vos informations de connexion.",
      "maxConnectionReached": "Vous avez atteint le nombre maximum de connexions gratuites."
    },
    "delete": {
      "title": "Suppression de connexion",
      "description": "Voulez-vous vraiment supprimer cette connexion ?",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "requestDeleteSuccessTitle": "Supprimé avec succès !",
      "requestDeleteSuccessText": "Vous avez réussi à supprimer votre connexion."
    },
    "transfer": {
      "title": "Gestionnaire de connexions",
      "connectionDetails": "Détails de connexion",
      "type": "Type",
      "hostName": "Nom d'hôte",
      "rootPath": "Chemin d'accès à la racine",
      "authType": "Type d'authentification",
      "username": "Nom d'utilisateur",
      "verificationStatus": "Statut de vérification",
      "disclaimer": "Démenti",
      "disclaimerText": "En confirmant votre sélection, vous reconnaissez que la connexion choisie est indépendante de la volonté de Telekom Data Intelligence Hub. Par conséquent, vous assumez la responsabilité de tout problème de transfert de données résultant de facteurs externes, y compris, mais sans s'y limiter, un stockage insuffisant, une connectivité réseau, des restrictions d'accès et d'authentification et d'autres considérations pertinentes.",
      "confirmSelection": "Confirmer la sélection",
      "newConnection": "Nouvelle connexion",
      "noConnectionModalTitle": "Vous n'avez pas encore de connexions",
      "noConnectionModalDesc": "Vous pouvez créer une nouvelle connexion en cliquant sur le bouton ci-dessous.",
      "noConnectionAddNewButton": "Ajouter une nouvelle connexion",
      "successModalTitle": "Le transfert prendra plus de temps que d’habitude",
      "successModalDesc": "Nous vous enverrons une notification une fois le transfert de fichier terminé.",
      "successModalAction": "Accédez à Données entrantes"
    }
  },
  "error": {
    "pageNotFound": "Page introuvable (404)",
    "unauthorized": "Accès non autorisé (403)"
  },
  "helpWidget": {
    "askSupport": "Demander de l’aide",
    "chatboxTitle": "Chat d’aide",
    "chatboxSubtitle": "Prise en charge de Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Bonjour, bienvenue sur le canal d’assistance Telekom Data Intelligence Hub. Veuillez sélectionner une option ci-dessous."
    },
    "whatCanWeHelpWith": "En quoi pouvons-nous vous aider aujourd’hui ?",
    "suggestedAnswers": {
      "knowledgeBase": "Base de connaissances, documentation et FAQ",
      "contactSupport": "Contacter l'assistance",
      "contactSales": "Contacter le service commercial"
    }
  },
  "partnerNetworkManagement": {
    "title": "Gestion du réseau de partenaires",
    "hint": "Cette page permettra aux utilisateurs d'inviter des organisations partenaires au Telekom Data Intelligence Hub et de surveiller le statut des invitations.",
    "noInvitations": {
      "title": "Vous n'avez encore invité aucune organisation",
      "actionButtonText": "Inviter une organisation"
    },
    "overview": {
      "title": "Aperçu des invitations de partenaires",
      "actionButtonText": "Inviter des organisations",
      "dateOfInvitation": "Date de l'invitation",
      "resendInvitation": "Renvoyer l'invitation",
      "deleteInvitation": "Supprimer l'invitation",
      "resendReminderInfo": "Vous pouvez renvoyer l'invitation dès que 24 heures se sont écoulées depuis le dernier email d'invitation.",
      "invitedBy": "Invité par"
    },
    "information": {
      "title": "Informations importantes",
      "description": "La personne de contact assumera le rôle \"d'Administrateur\" au sein du Telekom Data Intelligence Hub. En tant qu'administrateur, elle aura l'autorité d'ajouter ou de supprimer des utilisateurs de sa propre organisation, de superviser les rôles et de prendre des décisions commerciales concernant les services que nous proposons. Nous transmettrons les étapes suivantes pour l'intégration de l'organisation à la personne de contact par email, et vous pourrez suivre les progrès dans la page \"Aperçu des invitations de partenaires\"."
    },
    "invite": {
      "additionalText": "Veuillez décider si vous souhaitez inviter des organisations individuellement ou en masse - et faites votre sélection ci-dessous.",
      "bulkInvite": "Invitations en masse",
      "bulkInviteHint": "Si vous souhaitez effectuer une invitation en masse (>5 invitations), veuillez sélectionner cette option.",
      "limitationHint": "Limite : Maximum 5 organisations. Pour en ajouter davantage, veuillez sélectionner \"Invitations en masse\".",
      "singleInvite": "Invitation individuelle",
      "singleInviteHint": "Pour inviter jusqu'à 5 organisations, veuillez sélectionner cette option.",
      "orgNameLabel": "Entrez le nom de l'organisation partenaire",
      "emailLabel": "Entrez l'e-mail du contact",
      "groupInvite": "Invitation de groupe",
      "groupInviteHint": "Si vous souhaitez inviter plusieurs groupes, veuillez sélectionner cette option.",
      "groupInviteInfo": "Vous pouvez ajouter plusieurs groupes. Limite : maximum 5 invitations de groupe.",
      "groupDetails": "Détails du groupe :",
      "groupSelect": "Sélectionnez un groupe et à ajouter",
      "groupRequired": "Le champ Nom du groupe est obligatoire",
      "groupUnique": "Ce groupe a déjà été ajouté",
      "groupCreate": "+ Créer un nouveau groupe"
    },
    "inviteStatus": {
      "INVITED": "Invité",
      "COMPLETED": "Accepté",
      "FAILED": "Rejeté"
    },
    "upload": {
      "hint": "Pour inviter plusieurs organisations, veuillez suivre les étapes suivantes :",
      "step1": "Téléchargez le fichier modèle via le lien ci-dessous",
      "step2": "Remplissez le fichier fourni avec les détails des invités",
      "step3": "Téléchargez le fichier dans la zone prévue",
      "downloadTemplate": "Télécharger le modèle",
      "templateHeader": {
        "organizationName": "nom_de_l_organisation",
        "email": "courriel"
      },
      "templateFileName": "modele_d_invitations_en_gros.csv",
      "learnMore": "Si vous souhaitez en savoir plus sur l'invitation en masse, veuillez {clickHere}.",
      "clickHere": "cliquer ici"
    },
    "report": {
      "invitationsInProgress": "Invitation(s) {type} en cours",
      "invitationsSent": "Invitation(s) envoyées",
      "error": {
        "errorsInInvitations": "Erreurs dans {result} invitations envoyées",
        "single": {
          "invalidEmail": "L'adresse e-mail est invalide",
          "pleaseEnterValidEmail": "Veuillez entrer une adresse e-mail valide",
          "pleaseEnterValidOrganization": "Le champ Nom de l’organisation peut contenir uniquement des lettres, des chiffres, des espaces et les caractères suivants : & _ . - ' , ( ) +",
          "emailUnique": "L'email doit être unique",
          "pleaseEnterValidName": "Veuillez entrer un nom valide"
        },
        "bulk": {
          "allowedFileExtension": "Seuls les fichiers avec l'extension csv sont autorisés",
          "fileIsTooBig": "Le fichier est trop volumineux. Vous pouvez télécharger des fichiers jusqu'à 1 Mo",
          "formatMismatch": "Le fichier ne correspond pas au format attendu. Veuillez utiliser le modèle fourni et réessayer",
          "duplicateEmail": "Le fichier contient {number} {duplicate}",
          "duplicate": "doublon | doublons",
          "fileHasNoEntries": "Le fichier ne contient aucune entrée",
          "invalidEmailAddresses": "{number} adresses e-mail sont invalides.",
          "invalidOrganizationNames": "{number} organisations ont des noms invalides.",
          "organizationAlreadyInvited": "{number} organisations ont déjà été invitées par votre organisation.",
          "kindlyDownloadReport": "Veuillez télécharger le rapport pour voir plus de détails",
          "limitExceededError" : "Vous avez dépassé le quota maximal de connecteur conformément à l'accord contractuel. Vous ne pouvez inviter {limit} plus de participants que dans un ton limité. Veuillez contacter {email} pour modifier le contrat et augmenter la quota. De plus, vous pouvez retirer les invitations en attente pour libérer le quota.",
          "noQuotaLeftError" : "Vous avez épuisé le quota maximum de connecteur conformément à l'accord contractuel. Vous ne pouvez plus inviter de participants. Veuillez contacter {email} pour modifier le contrat et augmenter la quota. De plus, vous pouvez retirer les invitations en attente pour libérer le quota."
        },
        "processing": {
          "DUPLICATE_EMAILS": "E-mails en double détectés",
          "EMAIL_ALREADY_EXIST": "L'e-mail existe déjà.",
          "SOMETHING_WENT_WRONG": "Quelque chose a mal tourné.",
          "INVALID_EMAIL_FORMAT": "Format d'e-mail invalide.",
          "ALREADY_REGISTERED_DATASPACE_USER": "L’utilisateur fait déjà partie de {dataspaceName}."
        }
      },
      "template": {
        "fileName": "rapport_des_invitations_en_gros.csv"
      }
    },
    "abort": {
      "title": "Annuler l'invitation",
      "confirmText": "Êtes-vous sûr de vouloir fermer ce processus ?",
      "informationText": "Vos invitations ne seront pas envoyées."
    },
    "switchForm": {
      "title": "Abandonner les modifications",
      "confirmText": "Êtes-vous sûr de vouloir changer de formulaire ?",
      "informationText": "Vos modifications ne seront pas conservées."
    }
  },
  "discover": {
    "welcome": {
      "title": "Découvrez les offres data de nos partenaires et fournisseurs de confiance",
      "description1": "Prenez des décisions basées sur les données.",
      "description2": "Les données jouent un rôle central dans les opérations commerciales, remplissant diverses fonctions essentielles telles que l’épine dorsale pour la prise de décision, la segmentation du marché et la génération de prospects. Les données peuvent faire ou défaire le développement de vos produits, optimiser la logistique de votre chaîne d’approvisionnement ou fournir à votre IA les informations dont elle a besoin pour tirer les conclusions dont vous avez besoin pour atteindre vos objectifs.",
      "description3": "Au sein du Data Intelligence Hub de Telekom, nous proposons une plate-forme unifiée pour les fournisseurs de données dans toute l’Allemagne. Explorez vos options et plongez dans le vif du sujet : vous trouverez peut-être une solution idéale pour vos besoins en matière de données. Nous élargissons constamment notre réseau de fournisseurs de données, donc même si vos besoins exacts ne sont pas couverts par notre offre de données actuelle, ne soyez pas un étranger : votre adéquation parfaite avec les données pourrait être dans quelques jours.",
      "buttonLabel": "Explorer les produits de données"
    },
    "dataOffers": {
      "title": "Offres de Données",
      "filter": {
        "subjectAreas": "Domaines d'études",
        "dataOfferingType": "Type d'offre de données",
        "dataProvider": "Fournisseur de données"
      },
      "tiles": {
        "productType": "Produit de données configurable",
        "dataspaceName": "Espace de Données du Data Intelligence Hub",
        "subjectArea": "Domaine d'études",
        "massmovementAnalytics": "Analyses des mouvements de masse",
        "termsOfUse": "Conditions d'utilisation",
        "licensedRestricted": "Sous licence, restreint",
        "viewOffer": "Voir l'offre",
        "product1": {
          "name": "Traffic Analytics par Motion Data",
          "summary": "Statistiques détaillées du comportement de déplacement en Allemagne, y compris la direction du déplacement, l'origine, la destination, permettant des analyses à différents niveaux spatiaux dans n'importe quelle région."
        },
        "product2": {
          "name": "Traffic Analytics PRO par Motion Data",
          "summary": "Mesures détaillées des déplacements en Allemagne, y compris la direction du déplacement, l'origine, la destination, permettant des analyses et des comparaisons à différents niveaux spatiaux à tout moment et dans n'importe quelle région."
        },
        "product3": {
          "name": "Visitor Analytics PRO par Motion Data",
          "summary": "Analyse des informations sur le comportement des visiteurs en raison des schémas de déplacement public, y compris le nombre total d'utilisateurs par jour et par heure, des informations sociodémographiques et les détails d'origine des visiteurs dans n'importe quelle région de l'Allemagne. Prochain niveau d'options d'analyse pour le comportement des visiteurs sur site, combinant les avantages de l'un des plus grands échantillons et une précision spatiale sans précédent."
        }
      },
      "offerDetails": {
        "title": "Détails de l'offre",
        "requestADemo": "Demander une démo",
        "orderNow": "Commander maintenant",
        "productOverview": {
          "title": "Aperçu du produit",
          "whatUseCasesAreAddressed": "Quels sont les cas d'utilisation traités ?",
          "exampleCarousel1": {
            "title": "Évaluation des grands événements",
            "text": "Obtenez des informations plus approfondies sur les participants aux événements afin de planifier efficacement et de surmonter les obstacles logistiques, de sélectionner les fournisseurs et sponsors appropriés pour l'événement et de prioriser les mesures de sécurité en utilisant les données de densité de foule avec une résolution spatiale plus élevée."
          },
          "exampleCarousel2": {
            "title": "Aperçus de la planification touristique",
            "text": "Les autorités touristiques peuvent utiliser les données de fréquentation pour améliorer la planification et l'allocation des ressources, facilitant ainsi le développement d'une meilleure infrastructure dans les points chauds du tourisme. Cela inclut la mise en place d'un réseau de transport sans faille selon l'analyse du trafic piétonnier aux heures de pointe, la réalisation de campagnes marketing ciblées et la planification des services d'urgence et de sécurité."
          },
          "exampleCarousel3": {
            "title": "Centres commerciaux et informations sur le commerce de détail",
            "text": "Les informations sur le commerce de détail peuvent révéler le nombre de clients potentiels qu'un centre commercial, un outlet ou une rue commerçante attire et d'où ils viennent. Elles fournissent des données sur la durée de séjour des visiteurs, leur composition socio-démographique et leur pouvoir d'achat. En analysant ces modèles au fil du temps, on peut identifier les tendances du comportement des visiteurs. Ces informations aident également à déterminer s'il existe de meilleurs emplacements alternatifs et à évaluer la situation dans les lieux concurrents."
          },
          "exampleCarousel4": {
            "title": "Planification urbaine et évaluation",
            "text": "L'analyse des données démographiques dynamiques permet une planification efficace des zones résidentielles et de l'infrastructure pour répondre aux besoins des résidents. L'utilisation efficace des ressources est un autre domaine d'application important ; les villes peuvent ainsi réduire leur consommation d'énergie et contribuer à la durabilité."
          },
          "fromDataIntelligenceHub": {
            "title": "Que recevez-vous du Telekom Data Intelligence Hub ?",
            "ol": {
              "1": "Vous pouvez demander une démonstration du fournisseur de données (Motion Data de T-Systems International GmbH) et obtenir des informations approfondies sur ce produit de données de la part de nos experts de confiance.",
              "2": "Pour les produits commandables du fournisseur de données (Motion Data de T-Systems International GmbH) :"
            },
            "ul": {
              "1": "Vous recevrez les rapports de produits de données achetés sous forme de fichiers CSV pour la plage de dates, les emplacements et les métriques demandées.",
              "2": "Une application \"Connecter & Intégrer\" vous sera proposée pour vous connecter au fournisseur de données et accéder aux rapports achetés.",
              "3": "Les rapports peuvent être téléchargés depuis la vue \"Consommer\" dans l'application \"Connecter & Intégrer\".",
              "4": "De plus, des solutions de tableau de bord peuvent être demandées à MotionData pour votre produit de données acheté.",
              "5": "Le support et le service d'assistance sont disponibles par e-mail et par ligne d'assistance pendant les heures de bureau en allemand et en anglais."
            }
          }
        },
        "generalInformation": {
          "availability": "Disponibilité de la plage horaire",
          "contactProvider": "Contacter le fournisseur",
          "coverage": "Couverture géographique",
          "documentation": "Documentation",
          "guide": "Guide de démarrage",
          "help": "Aide",
          "message": {
            "coverage": "Vous souhaitez acheter des informations sur les visiteurs pour un autre pays? {link}",
            "coverageLinkText": "Contactez-nous",
            "segmentation": "Veuillez consulter {link} pour plus d’informations.",
            "segmentationLinkText": "notre base de connaissances"
          },
          "missing": {
            "availability": "N/A",
            "coverage": "Aucune couverture géographique n’est précisée.",
            "description": "Aucune description disponible.",
            "provider": "Fournisseur inconnu.",
            "segmentation": "Aucune segmentation spatiale disponible.",
            "source": "Aucune source de données disponible.",
            "visualization": "Aucune visualisation de données disponible."
          },
          "mockData": {
            "dataSpace": "Centre d’intelligence des données Dataspace",
            "dataProvider": "MotionData de T-Systems International GmbH",
            "dataSource": "Données de signalisation anonymisées et agrégées (actives et passives) des abonnés à la téléphonie mobile sur le réseau de Deutsche Telekom (y compris les roamers) en Allemagne.",
            "dataVisualization": "Des tableaux de bord perspicaces et faciles à utiliser sont disponibles sur demande auprès du fournisseur de données.",
            "description": "L’analyse des visiteurs offre des options d’analyse de niveau supérieur pour le comportement des visites sur site depuis n’importe quel endroit en Allemagne. En exploitant les données historiques dérivées des données de signalisation mobile anonymisées fournies par le réseau cellulaire de Deutsche Telekom, et en combinant les avantages de l’un des plus grands échantillons et d’une précision spatiale sans précédent, l’analyse des visiteurs permet aux entreprises et aux instituts de développer des stratégies optimales pour accélérer leur croissance grâce à des décisions intelligentes basées sur les données.Ce produit de données est disponible sous forme de rapports sous forme de fichiers CSV et est livré via nos solutions de connecteurs de confiance via l’espace de données Data Intelligence Hub.",
            "from": "01/07/2024",
            "geographicalCoverage": "Allemagne",
            "geoLocationData": "Données de géolocalisation",
            "location": "Frankfurt am Main, Allemagne",
            "locationType": "Quartier général",
            "logo": "testLogoString",
            "massMovementAnalytics": "Analyse des mouvements de masse",
            "spatialSegmentation": "Tout emplacement (défini par un polygone ou une coordonnée x/y) avec une zone tampon donnée de 150 m / 300 m.",
            "to": "Présent",
            "verificationLabel": "Entité juridique vérifiée par le nœud Gaia-X Digital Clearing House de T-Systems"
          },
          "provider": "Fournisseur de données",
          "segmentation": "Segmentation spatiale",
          "source": "Source des données",
          "title": "Informations générales",
          "visualization": "Visualisation des données"
        },
        "sampleData": {
          "title": "Données de l'échantillon",
          "dataPackage": "Paquet de données",
          "description": "Description",
          "descriptionText": "Nombre de visiteurs uniques dans le temps (par jour ou par heure de l’heure de début) plus le nombre de visiteurs quotidiens ventilés par âge, sexe, zone d’origine (code postal / département) et informations d’itinérance.",
          "sampleDataFile": "Fichier de données d'exemple",
          "sampleDataFileDescription": "Comptes uniques de visiteurs quotidiens pour les POI (Points d'intérêt) fournis",
          "schemaInformation": "Informations sur le schéma",
          "referenceDocumentation": "Documentation de référence",
          "totalFiles": "Nombre total de fichiers de données",
          "fileName": {
            "pointsOfInterest": "Points d’intérêt",
            "productDescription": "Description du produit",
            "referenceShape": "Fichiers de forme de référence",
            "reports": "Rapports",
            "roamerReference": "Description de référence du roamer"
          }
        },
        "termsOfUse": {
          "allowed": "Vous pouvez:",
          "mandatory": "Il le faut:",
          "mockData": {
            "mock1": "Utiliser les données à des fins commerciales",
            "mock2": "Traiter les données sur l’infrastructure en dehors de l’Union européenne",
            "mock3": "Revendre les données",
            "mock4": "Respecter le contenu du Contrat de Licence",
            "mock5": "Conditions générales de vente_Anglais",
            "mock6": "Conditions générales de vente_Allemand"
          },
          "notAllowed": "Tu peux pas:",
          "title": "Conditions d'utilisation"
        },
        "additionalInformation": {
          "label": "Libellé du champ:",
          "mockData": {
            "description": "Description of a metadata block. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
          },
          "title": "Informations complémentaires"
        }
      },
      "orderVAPro": {
        "title": "Prenez des décisions basées sur les données !",
        "step1SubTitle": "Configurez votre offre de données selon les champs demandés par le fournisseur",
        "step2SubTitle": "Fournir des informations sur les spécifications de la zone",
        "step1of4": "Étape 1 sur 4",
        "step2of4": "Étape 2 sur 4",
        "step3of4": "Étape 3 sur 4",
        "step4of4": "Étape 4 sur 4",
        "features": {
          "title": "Visitor Analytics Pro",
          "feature1": "Prise en charge haute résolution de polygones prédéfinis jusqu'à 150m de rayons",
          "feature2": "Sélection pour plusieurs jours et polygones possibles par commande",
          "feature3": "Le produit comprend des données horaires et quotidiennes sur le nombre de visiteurs uniques et d'autres indicateurs clés",
          "feature4": "Les tableaux de bord et la consultation sont disponibles sur demande",
          "feature5": "Mode de livraison des fichiers de données de manière transparente et sécurisée via des solutions Connect & Integrate de confiance."
        },
        "dateTitle": "Plage de temps",
        "dateTooltip": "Spécifiez une période allant d'un minimum de 1 jour sur laquelle vous souhaitez analyser les rapports Visitor Analytics Pro. L'intervalle de temps fait référence à la période pendant laquelle les données sont collectées, mesurées et traitées, et sont préparées pour l'analyse",
        "areaSelectionTitle": "Sélection de zone",
        "areaSelectionTooltip": "La sélection de zones dans une distribution de données implique de réduire l'ensemble de données pour n'inclure que les observations ou mesures qui se rapportent à une zone géographique d'intérêt particulière.",
        "validDays": "Nombre total de jour(s) valide(s) :",
        "segmentTypeLabel": "Sélectionner le type de segmentation spatiale",
        "informationTypeLabel": "Comment souhaitez-vous fournir ces informations",
        "totolPOICount": "Nombre total de points d'intérêt :",
        "confirmSelection": "Confirmer la sélection",
        "totalPOICounts": "Nombre total de points d'intérêt :",
        "priceFetchingProgressMsg": "Nous récupérons vos prix...",
        "priceFetchingError": "Impossible de récupérer vos prix",
        "totalPriceText": "Prix total :",
        "vatText": "(hors TVA)",
        "premiumCustomerHighlight": "Avec une commande supérieure à 10.000 €, vous êtes notre client Premium. Nous vous contacterons dans un e-mail séparé pour discuter d'autres options de collaboration.",
        "reviewPageHeading": "Récapitulatif de votre commande",
        "name": "Nom",
        "monthlyCharges": "Frais mensuels",
        "oneTimeCharges": "Frais uniques",
        "yourSelectedProduct": "Le produit que vous avez sélectionné",
        "product": "Produit",
        "timeSelection": "Sélection de l'heure",
        "type": "Type :",
        "areaSelection": "Sélection de zone",
        "spatialInput": "Entrée spatiale : Points d'intérêt (POI)",
        "inputType": "Type d'entrée : Sélectionner des POI prédéfinis",
        "viewMap": "Voir la carte",
        "additionalServices": "Services supplémentaires",
        "supportServices": "Services d'assistance",
        "essentialSupport": "Support essentiel 5/8",
        "totalAmount": "Montant total (euro)",
        "resultSuccessHeading": "Merci d'avoir passé la commande",
        "resultParaText1": "Vos fichiers seront disponibles sous peu, merci de votre patience.",
        "resultParaText2": "Si vous avez des questions ou des requêtes, n'hésitez pas à nous contacter.",
        "membershipBtn": "Aller à Mon adhésion",
        "mapPoi": "POI :",
        "mapCity": "Ville :",
        "mapCoordinates": "Coordonnées :",
        "pickDate": "Choisissez une date",
        "from": "De",
        "to": "À",
        "selectDate": "Sélectionnez une date",
        "poiDropdown": "Points d'intérêt (POI)",
        "mapSelection": "Sélectionner des points d'intérêt (POI) sur une carte",
        "fileUpload": "Téléverser les fichiers de formes des POI préférés",
        "predefinedSelection": "Sélectionner des points d'intérêts prédéfinis"
      }
    }
  },
  "ospOnboarding": {
    "help": "Ici",
    "welcome": {
      "title": "Bienvenue sur Catena-X - Le réseau automobile",
      "card": {
        "note": "Veuillez remplir le formulaire suivant pour compléter l'inscription de votre entreprise à Catena-X.",
        "point-1": "Le formulaire d'inscription se compose de 3 étapes et prendra environ 5 à 10 minutes de votre temps.",
        "point-2": "Comme votre organisation est déjà inscrite sur Telekom Data Intelligence Hub, nous préremplirons le formulaire avec vos données disponibles pour rendre le processus de complétion aussi fluide et facile que possible.",
        "point-3": "Vous pouvez consulter notre guide d'aide sur notre base de connaissances à tout moment pour mieux comprendre ce processus d'inscription. Veuillez cliquer {hereLink} pour en savoir plus.",
        "here": "Ici",
        "letStarted": "Commençons"
      }
    },
    "title": "Inscription à l'écosystème Catena-X",
    "description": "Inscrivez-vous à Catena-X en saisissant toutes les informations demandées dans les 3 étapes suivantes.",
    "description2": "Veuillez terminer l'intégration de votre entreprise en accomplissant les tâches suivantes afin de participer activement et d'utiliser toutes les fonctions du portail du réseau automobile Catena-X.",
    "note": "Veuillez saisir toutes les informations requises avant de continuer. Plus d'informations dans notre {help}.",
    "companyDataStepTitle": "Données de l’entreprise",
    "companyRoleStepTitle": "Rôle de l’entreprise",
    "verifyAndSubmitStepTitle": "Vérifier et soumettre",
    "companyData": {
      "title": "Ajoutez les données de votre entreprise",
      "description": "Veuillez ajouter ci-dessous les données de votre entité juridique. Les champs obligatoires sont mis en évidence par un (*) et le formulaire est pré-rempli avec les informations que vous nous avez déjà fournies lors de l’intégration.",
      "organizationName": "Nom de l’organisation",
      "organizationNameTooltip": "Nom de l’organisation enregistrée",
      "enterYourData": "Veuillez saisir vos données",
      "bpn": "Numéro de partenaire commercial",
      "bpnTooltip": "Le numéro de partenaire commercial (BPN) est un identifiant unique attribué à chaque partenaire commercial dans le cadre de l'écosystème Catena-X.",
      "legalEntityName": "Nom de l'entité légale",
      "transliteratedName": "Nom translittéré (Caractères latins)",
      "registeredName": "Nom enregistré",
      "orgAddress": "Adresse de l'organisation",
      "streetName": "Nom de la rue",
      "houseNumber": "Numéro de maison",
      "postCode": "Code postal",
      "city": "Ville",
      "countryCode": "Code pays",
      "region": "Région",
      "companyIdentifier": "Identifiant de l’entreprise",
      "identifierType": "Type d'identifiant",
      "identifierNumber": "Numéro d'identification",
      "contactInfo": "Coordonnées",
      "emailAddress": "Adresse e-mail",
      "userRole": "Rôle de l'utilisateur",
      "CRN": {
        "label": "Numéro de registre commercial",
        "helpText": "Exemple: HRB 55933",
        "tooltipText": "Le numéro de registre commercial (CRN) est un identifiant unique attribué aux entreprises pour leur enregistrement commercial légal. Il est utilisé pour valider et vérifier l'authenticité des identifiants d'enregistrement et de transaction financière d'une entreprise contre les sources de données de confiance."
      },
      "vatId": {
        "label": "numéro de TVA",
        "helpText": "Exemple: DE 118 645 675",
        "tooltipText": "Un numéro de TVA (numéro d'identification fiscale à valeur ajoutée) est un identifiant unique attribué aux entreprises à des fins fiscales."
      }
    },
    "companyRole": {
      "title": "Le rôle de votre entreprise",
      "description": "Veuillez sélectionner un ou plusieurs rôles d'entreprise avec lesquels vous souhaitez agir/participer dans le réseau Catena-X. Le rôle de l'entreprise peut toujours être mis à jour/modifié ultérieurement. Selon le rôle sélectionné, les services proposés sur le portail peuvent différer.",
      "activeParticipanyNote": "Adaptez et optimisez votre participation à Catena-X avec T-Systems Connect & Integrate pour une connexion facile et automatisée à Catena-X. Commandez le Connect & Integrate depuis la place de marché de l'application Cofinity pour les cas d'utilisation principaux de Catena-X et commencez immédiatement à échanger des données ! À partir de 49 EUR/mois et disponible pour toutes les tailles d'entreprises.",
      "agreeTermsCheckbox": "Oui, j'accepte le {link} du rôle sélectionné",
      "activeParticipantNote": {
        "para1": "Adaptez et optimisez votre participation à Catena-X avec {link} pour une connexion facile et automatisée à Catena-X.",
        "tSystemsConnectAndIntegrate": "T-Systems Connect & Integrate",
        "para2": "Commandez le Connect & Integrate depuis la place de marché de l'application Cofinity pour les cas d'utilisation principaux de Catena-X et commencez immédiatement à échanger des données !",
        "para3": "À partir de {price}/mois et disponible pour toutes les tailles d'entreprises."
      },
      "appProviderNote": {
        "para1": "{link} vous permet de développer, gérer et certifier des applications d’entreprise dans notre environnement officiel Catena-X Sandbox.",
        "para2": "Commandez Build & Operate dès aujourd’hui et laissez-nous gérer votre infrastructure d’espace de données pendant que vous vous concentrez sur l’innovation !",
        "para1PlaceholderLink": "Build & Operate de T-Systems",
        "optionalInformation": "Informations facultatives"
      }
    },
    "verifyAndSubmit": {
      "title": "Vérifiez vos données d'inscription",
      "description": "Vérifiez les données d'inscription de votre entreprise avant de soumettre l'inscription. Veuillez-vous assurer que toutes les informations sont correctement remplies. Dès que la vérification est terminée, cliquez sur le bouton Soumettre ci-dessous pour soumettre l'inscription pour approbation.",
      "companyData": "Données de l'entreprise",
      "activeRole": "Rôle actif",
      "consentText": "Je consens à ce que T-Systems International GmbH soumette ma demande d’inscription à Cofinity-X GmbH et traite les données personnelles pertinentes dans le but de mener à bien la procédure d’intégration et à des fins connexes. Je reconnais que mes données seront traitées conformément aux lois et réglementations applicables en matière de protection des données, y compris, mais sans s’y limiter, le Règlement général sur la protection des données (RGPD). Je comprends que mes données personnelles ne seront conservées qu’aussi longtemps que nécessaire pour atteindre ces objectifs. Je suis conscient que ce consentement est nécessaire pour l’inscription et l’intégration chez Cofinity-X GmbH, et que je peux retirer mon consentement à tout moment avec effet pour l’avenir."
    },
    "actions": {
      "back": "Retour",
      "next": "Suivant",
      "submit": "Envoyer"
    },
    "validation": {
      "DE_COMMERCIAL_REG_NUMBER": "Veuillez entrer un numéro valide. Astuce : alphanumérique avec trait d'union et espace avec exactement 9 chiffres.",
      "DE_VAT_ID": "Veuillez entrer un numéro valide. Astuce : Commençant par DE et suivi de nombres à 9 chiffres",
      "Worldwide_COMMERCIAL_REG_NUMBER": "Veuillez entrer un numéro valide. Astuce : Alphanumérique avec tirets de 6 à 21 chiffres.",
      "Worldwide_VAT_ID": "Veuillez entrer un numéro valide. Astuce : alphanumérique avec trait d'union et espace de 8 à 15 chiffres.",
      "invalid_bpn": "Numéro BPN non valide. Le numéro BPN doit commencer par BPNL suivi de 12 caractères alphanumériques."
    },
    "error": {
      "title": "Erreur de validation",
      "para": "Soit votre organisation existe déjà au sein du réseau Cofinity-X, soit des problèmes techniques sont en cours de résolution. N’hésitez pas à nous en dire plus sur votre expérience afin que nous puissions vous aider davantage.",
      "buttonText": "Contactez-nous"
    },
    "success": {
      "title": "Merci d'avoir soumis votre demande",
      "para": "Vos coordonnées ont été envoyées à Cofinity-X, vous recevrez des informations sur les prochaines étapes par e-mail",
      "buttonText": "Aller vers la page d'accueil"
    }
  },
  "demoOrg": {
    "title": "Organisation de démonstrations",
    "tooltip": "Il s’agit d’une organisation de démonstration / évaluation.",
    "tooltip1": "Certaines fonctionnalités peuvent être limitées."
  }
}